<template>
  <v-container class="ma-0 pa-0" fluid>
    <v-data-table
      :headers="displayHeaders"
      :height="tableSize"
      :items-per-page="pageSize"
      :items="items"
      :loading="loading"
      :search="search"
      :item-class="getRowClass"
      loading-text="Loading Items...Please Wait"
      loader-color="orange"
      dense
      fixed-header
      hide-default-footer
      item-key="id"
      :expanded="expanded"
      :show-expand="isTprProRetailUser && storeGroupSelected"
      :single-expand="false"
      :show-select="!isEditingDisabled"
      :disable-sort="true"
      class="dark-dividers"
      ref="dataTable"
      v-model="selected">
      <template v-for="header in allHeaders" v-slot:[`header.${header.value}`]="">
        <div :key="header.value" @click="handleSort(header)">
          {{ header.text }}
          <v-icon v-if="header.showArrow && !header.descending" small color="white">mdi-chevron-up</v-icon>
          <v-icon v-if="header.showArrow && header.descending" small color="white">mdi-chevron-down</v-icon>
          <v-icon
            v-if="header.showArrow"
            color="red"
            small
            @click.stop="removeSort(header)"
            style="position: absolute; top: 0; right: 0; cursor: pointer;">
            mdi-close
          </v-icon>
        </div>
      </template>
      <template #top>
        <v-toolbar flat color="toolbar">
          <v-row dense align="center" class="flex-right">
            <v-btn
                v-if="selectedStoreParty && selectedStoreParty.party_type === 'TPR_STORE_GROUP'"
                height="40"
                depressed
                color="primary"
                style="border: 1px solid #9e9e9e; border-left: 0px; border-right: 0px"
                @click="storeGroupModal = true">
                <v-icon color="white">mdi-store</v-icon>
              </v-btn>
            <v-col cols="4"
              @mouseenter="showExpanded=true"
              @mouseleave="showExpanded=false">
              <v-breadcrumbs large :items="breadcrumbs">
                <template #item="{ item }">
                  <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                    <span :class="!item.disabled ? 'primary--text' : ''">{{
                        showExpanded && item.expanded_text ? item.expanded_text : item.text
                      }}</span>
                  </v-breadcrumbs-item>
                </template>
              </v-breadcrumbs>
            </v-col>
            <v-spacer />
            <v-menu bottom offset-y nudge-bottom="5" :value="infoMenu" class="">
              <template v-slot:activator="{ on: menu , attrs}">
                <v-tooltip top>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-badge v-show="hasWarnings" overlap :content="toolbarWarnings.length" bordered left :color="toolbarWarningsColor">
                      <v-btn :color="toolbarWarningsColor" outlined class="px-0" v-bind="attrs" v-on="{...tooltip, ...menu}" @click="infoMenu = true">
                        <v-icon class="px-0">mdi-information</v-icon>
                      </v-btn>
                    </v-badge>
                  </template>
                  <span>Info and Warnings</span>
                </v-tooltip>
              </template>
              <v-card outlined class="px-2 py-1">
                <v-alert 
                  v-for="(alert, index) in toolbarWarnings"
                  :key="index"
                  :type="alert.type"
                  dense
                  outlined
                  class="my-2">
                  {{ alert.message }}
                </v-alert>
              </v-card>
            </v-menu>
            <v-menu v-if="isFiltered" bottom open-on-hover max-height="300">
              <template v-slot:activator="{ on }">
                <v-chip v-on="on" class="orange white--text ml-2">
                  <v-icon color="white" class="mr-2" small>
                    mdi-filter-outline
                  </v-icon>
                  <span class="text-capitalize">
                    Results for {{ searchValues.length }} search values
                  </span>
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <v-btn v-on="on" @click="searchValues = []" class="white--text ml-2" icon x-small>
                        <v-icon small>mdi-close-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Clear Filter</span>
                  </v-tooltip>
                </v-chip>
              </template>
              <v-card>
                <v-card-title class="text-subtitle-2 pb-0">
                  Search Values:
                </v-card-title>
                <v-list>
                  <v-list-item v-for="(value, index) in searchValues" :key="index">
                    {{ value }}
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
            <v-btn v-if="tprProTenants || tenant == 'awg'" class="grey lighten-2" @click="openModal">
              <v-icon>mdi-table-edit</v-icon>
            </v-btn>
            <v-menu
              v-if="$auth.tenant === 'alliance-retail-group'"
              :value="sessionMenu"
              bottom offset-y nudge-bottom="5"
              >
              <template v-slot:activator="{ on: menu }">
                <v-tooltip top>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn class="grey lighten-2"
                      v-on="{...tooltip, ...menu}"
                      @click="sessionMenu = true">
                      Session
                    </v-btn>
                  </template>
                  <span>Session controls</span>
                </v-tooltip>
              </template>
              <v-card color="white" class="d-flex flex-column px-2 py-1">
                  <v-tooltip right>
                    <template #activator="{ on }">
                      <v-btn  v-on="on" class="grey lighten-2 my-2" @click="saveCurrentSession">
                        Save Session
                      </v-btn>
                    </template>
                    <span>Save Current Session</span>
                  </v-tooltip>
                  <v-tooltip right>
                    <template #activator="{ on }">
                      <v-btn v-on="on" class="grey lighten-2 px-2 my-2" @click="triggerFileInput">
                        Load Session
                      </v-btn>
                    </template>
                    <span>Load Session State</span>
                  </v-tooltip>
              </v-card>
            </v-menu>
            <input
              v-if="$auth.tenant === 'alliance-retail-group'"
              ref="sessionFileInput"
              type="file"
              accept=".json"
              style="display: none"
              @change="handleFileSelect"
            />
            <v-dialog v-model="showModal" max-width="600px" scrollable persistent>
              <v-card>
                <v-card-title class="main white--text pa-2 centered-title">
                  <span>Ordering Headers</span>
                </v-card-title>
                <v-card-text>
                  <v-form>
                    <v-container>
                      <div class="row">
                        <!-- Draggable List 1 (Visible Headers) -->
                        <div class="col-6">
                          <h3 class="header-column-name">Display Order</h3>
                          <draggable class="list-group" :list="displayHeaders" group="headers" @end="onDragEnd">
                            <div v-for="header in displayHeaders" :key="header.value">
                              <div v-if="header.value !== 'data-table-select'" class="list-group-item">
                                {{ header.text }}
                              </div>
                            </div>
                          </draggable>
                        </div>
                        <!-- Draggable List 2 (Hidden Headers) -->
                        <div class="col-6">
                          <h3 class="header-column-name">Hide</h3>
                          <draggable class="list-group" :list="hideHeaders" group="headers" @end="onDragEnd">
                            <div
                              class="list-group-item"
                              v-for="header in hideHeaders"
                              :key="header.value">
                              {{ header.text }}
                            </div>
                          </draggable>
                        </div>
                      </div>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-divider thickness="2"/>
                <v-card-actions class="grey lighten-4">
                  <v-spacer />
                  <v-btn color="main white--text" @click="resetHeaders">Reset</v-btn>
                  <v-btn color="green darken-1 white--text" @click="saveHeadersOrder">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-menu
              :close-on-content-click="false"
              :nudge-bottom="3"
              :value="srpMenu"
              bottom>
              <template #activator="{ on: menu, attrs }">
                <v-tooltip top>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn :disabled="!selected.length || isEditingDisabled" small :readonly="!selected.length" @click="openBulkMenu"
                      class="grey lighten-2" height="38" v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                      <v-icon>mdi-pencil-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </template>
              <v-card class="fill" width="200">
                <v-card-title class="pb-0 text-subtitle-1"> Edit </v-card-title>
                <v-form class="px-4 pt-4" ref="form">
                  <v-text-field :rules="multiplierRules" background-color="input" dense label="Multiplier" outlined
                    type="number" v-model="multiplier">
                  </v-text-field>
                  <v-text-field :rules="srpRules" background-color="input" dense label="SRP" outlined placeholder="0.00"
                    autofocus prefix="$" type="number" @blur="handleSRPBlur(null, $event)" v-model="srp"
                    @keydown.enter="bulkUpdate">
                  </v-text-field>
                </v-form>
                <v-card-actions class="fill">
                  <v-spacer />
                  <v-btn :class="body" @click="; (srp = ''), (srpMenu = false)" text>
                    Cancel
                  </v-btn>
                  <v-btn :class="body" @click="bulkUpdate" class="blue white--text mr-2">
                    Update
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-menu v-if="tenant !== 'alliance-retail-group' && tenant !== 'awg'" :close-on-content-click="false" :nudge-bottom="3" :value="deleteMenu" bottom>
              <template #activator="{ on: menu, attrs }">
                <v-tooltip top>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn :disabled="!selected.length || isEditingDisabled" small :readonly="!selected.length" @click="deleteMenu = true"
                      class="grey lighten-2" height="38" v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </template>
              <v-card class="fill" width="200">
                <v-card-text align="center" class="black--text text-subtitle-1">
                  Delete {{ selected.length }} items?
                </v-card-text>
                <v-card-actions class="fill">
                  <v-spacer />
                  <v-btn :class="body" @click="deleteMenu = false" text>
                    Cancel
                  </v-btn>
                  <v-btn :class="body" @click="bulkDelete" class="red white--text mr-2">
                    Delete
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-btn color="success" :loading="loading" :disabled="hasInvalidInputs || isEditingDisabled" v-if="tprProTenants" @click="prepareToSave">
              <v-icon left>mdi-content-save</v-icon>
              Save
            </v-btn>
            <v-btn color="red" :loading="loading"
              v-if="tprProTenants && hasActiveChanges" @click="refreshPage"
              class="ml-2">
              <v-icon left>mdi-refresh-circle</v-icon>
              Reset All
            </v-btn>
            <SearchFilters v-if="!isTprProRetailUser" ref="searchFilters" v-model="searchParams" :categories="categoryList" :subcategories="subcategoryList"
              :departments="departmentList" :promoCategories="promoCategoryList" :vendors="vendorList"
              :batch_type="selectedBatch.batch_type" @input="getItems" @filters-cleared="onFiltersCleared"
              class="fixed-search-filters" />
            <SearchFilters v-else ref="searchFilters" v-model="searchParams" :categories="categoryList" :subcategories="subcategoryList" :departments="departmentList"
              :promoCategories="promoCategoryList" :vendors="vendorList" @input="getItems" @filters-cleared="onFiltersCleared" :batch_type="selectedBatch.batch_type" class="fixed-search-filters" />
            <div style="width: 10px;"></div>
            <v-tooltip top>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn v-show="showRemoveSortsButton" small class="red lighten-1" height="38" @click="removeAllSorts"
                  v-on="tooltip">
                  <v-icon color="white">mdi-sort-variant-remove</v-icon>
                </v-btn>
              </template>
              <span>Remove all custom ordering</span>
            </v-tooltip>
            <v-menu bottom :nudge-bottom="3" :close-on-content-click="false" :value="actionMenu">
              <template #activator="{ on: menu, attrs }">
                <v-tooltip top>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn :disabled="isSyncing" small class="grey lighten-2" height="38" v-bind="attrs"
                      v-on="{ ...tooltip, ...menu }" @click="actionMenu = true">
                      <v-icon>mdi-cog-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Batch Actions</span>
                </v-tooltip>
              </template>
              <v-card class="fill">
                <v-list class="fill">
                  <v-list-item v-for="(action, index) in actions" :key="index" link
                    @click="action.method(selectedBatch, selectedStore)">
                    <v-list-item-icon>
                      <v-icon>{{ action.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ action.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-row>
        </v-toolbar>
        <v-divider />
      </template>
      <template #loading>
        <v-container class="ml-0"> Loading Items...Please Wait </v-container>
      </template>
      <template #[`header.data-table-select`]="{ on, props }">
        <v-simple-checkbox :ripple="false" :disabled="isEditingDisabled" v-on="on" v-bind="props" dark />
      </template>
      <template #[`item.group_manager_modified`]="{ item, on }">
        <v-simple-checkbox
          :value="item.group_manager_modified === true"
          :ripple="false"
          v-on="on"
        />
      </template>
      <template #[`item.excluded`]="{ item, on }">
        <v-simple-checkbox
          :value="item.excluded === '' || item.excluded === null"
          :ripple="false"
          :disabled="isEditingDisabled"
          v-on="on"
          @click="toggleExcluded(item)"
        />
      </template>
      <template #[`item.rules_applied`]="{ item }">
        <v-tooltip top :disabled="!hasRules(item.rules_applied)">
          <template #activator="{ on }">
            <v-icon v-if="hasRules(item.rules_applied)" v-on="on" color="success">
              mdi-check-circle
            </v-icon>
          </template>
          <v-card v-if="hasRules(item.rules_applied)" width="300">
            <v-card-title class="text-subtitle-2">Applied Rules</v-card-title>
            <v-divider />
            <v-list dense>
              <v-list-item v-for="(rule, index) in parseRules(item.rules_applied)" :key="index">
                <v-list-item-content class="pl-4">
                  <v-list-item-title>Rule: {{ rule.display_name }}</v-list-item-title>
                  <v-list-item-subtitle>Level: {{ getRuleDisplay(rule.level) }}</v-list-item-subtitle>
                  <v-list-item-subtitle v-if="rule.priority != 52">Value: {{ rule.displayValue }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-tooltip>
      </template>
      <template #[`item.enforce_compliance`]="{ item }">
        <v-tooltip :disabled="!item.enforce_compliance" top>
          <template #activator="{ on }">
            <v-icon v-on="on" :color="item.enforce_compliance ? 'green' : 'grey lighten-1'">
              mdi-shield-check-outline
            </v-icon>
            <v-icon v-if="tprProTenants && item.enforce_compliance"
              v-show="!srpIsCompliant(item)" 
              v-on="on"
              :color="getWarningColor(item)">
              mdi-exclamation-thick
            </v-icon>
          </template>
          <span>Compliance Enforced</span>
          <br>
          <span>{{ 'Variance: $' + parseFloat(item.variance).toFixed(2) }}</span>
        </v-tooltip>
      </template>
      <template #[`item.upc`]="{ item }">
        <td class="noWrap">{{ item.upc > 2 ? item.upc : '' }}</td>
      </template>
      <template #[`item.cost`]="{ item }">
        <td class="noWrap">${{ formatCurrencyDisplay(item.cost) }}</td>
      </template>
      <template #[`item.case_freight`]="{ item }">
        <td class="noWrap">${{ item.case_freight ? formatCurrencyDisplay(item.case_freight) : formatCurrencyDisplay(item.cost) }}</td>
      </template>
      <template #[`item.amap_allowance`]="{ item }">
        <td class="noWrap">
          ${{ formatCurrencyDisplay(item.amap_allowance) }}
        </td>
      </template>
      <template #[`item.dsd_oi_allowance`]="{ item }">
        <td class="noWrap">
          ${{ formatCurrencyDisplay(item.dsd_oi_allowance) }}
        </td>
      </template>
      <template #[`item.early_buy_allowance`]="{ item }">
        <td class="noWrap">
          ${{ formatCurrencyDisplay(item.early_buy_allowance) }}
        </td>
      </template>
      <template #[`item.tpr_billback_allowance`]="{ item }">
        <td class="noWrap">
          ${{ formatCurrencyDisplay(item.tpr_billback_allowance) }}
        </td>
      </template>
      <template #[`item.tpr_scan_allowance`]="{ item }">
        <td class="noWrap">
          ${{ formatCurrencyDisplay(item.tpr_scan_allowance) }}
        </td>
      </template>
      <template #[`item.tpr_scan_epay_allowance`]="{ item }">
        <td class="noWrap">
          <div class="d-flex align-center" style="white-space: nowrap;">
            <span v-if="item.tpr_scan_epay_allowance !== 'N/A'">${{ formatCurrencyDisplay(item.tpr_scan_epay_allowance) }}</span>
            <span v-else>N/A</span>
            <v-tooltip 
              v-if="item.tpr_scan_epay_allowance && item.tpr_scan_epay_allowance !== 'N/A' && item.tpr_scan_epay_allowance > 0 && $auth.tenant === 'alliance-retail-group'"
              top
            >
              <template #activator="{ on }">
                <v-icon 
                  v-on="on" 
                  color="blue" 
                  small 
                  class="ml-1"
                  @mouseenter="loadPromotionData(item, 'tpr_scan_epay')"
                >
                  mdi-information
                </v-icon>
              </template>
              <div>
                <span class="font-weight-bold">TPR Scan ePay</span>
                <br>
                <span v-if="loadingPromoPrice && selectedPromotionCategory === 'tpr_scan_epay' && selectedPromotionItem === item">Loading promotion data...</span>
                <span v-else-if="promoPromotionPriceData && promoPromotionPriceData.promotion_price && selectedPromotionCategory === 'tpr_scan_epay' && selectedPromotionItem === item">
                  Promotion Price: ${{ formatCurrencyDisplay(promoPromotionPriceData.promotion_price) }}
                </span>
                <span v-else-if="selectedPromotionCategory === 'tpr_scan_epay' && selectedPromotionItem === item">No promotion price found</span>
                <span v-else>Hover to load promotion data</span>
              </div>
            </v-tooltip>
          </div>
        </td>
      </template>
      <template #[`item.tpr_scan_compete_allowance`]="{ item }">
        <td class="noWrap">
          <div class="d-flex align-center" style="white-space: nowrap;">
            <span v-if="item.tpr_scan_compete_allowance !== 'N/A'">${{ formatCurrencyDisplay(item.tpr_scan_compete_allowance) }}</span>
            <span v-else>N/A</span>
            <v-tooltip 
              v-if="item.tpr_scan_compete_allowance && item.tpr_scan_compete_allowance !== 'N/A' && item.tpr_scan_compete_allowance > 0 && $auth.tenant === 'alliance-retail-group'"
              top
            >
              <template #activator="{ on }">
                <v-icon 
                  v-on="on" 
                  color="blue" 
                  small 
                  class="ml-1"
                  @mouseenter="loadPromotionData(item, 'tpr_scan_compete')"
                >
                  mdi-information
                </v-icon>
              </template>
              <div>
                <span class="font-weight-bold">TPR Scan Compete</span>
                <br>
                <span v-if="loadingPromoPrice && selectedPromotionCategory === 'tpr_scan_compete' && selectedPromotionItem === item">Loading promotion data...</span>
                <span v-else-if="promoPromotionPriceData && promoPromotionPriceData.promotion_price && selectedPromotionCategory === 'tpr_scan_compete' && selectedPromotionItem === item">
                  Promotion Price: ${{ formatCurrencyDisplay(promoPromotionPriceData.promotion_price) }}
                </span>
                <span v-else-if="selectedPromotionCategory === 'tpr_scan_compete' && selectedPromotionItem === item">No promotion price found</span>
                <span v-else>Hover to load promotion data</span>
              </div>
            </v-tooltip>
          </div>
        </td>
      </template>
      <template #[`item.edlc_billback_allowance`]="{ item }">
        <td class="noWrap">
          ${{ formatCurrencyDisplay(item.edlc_billback_allowance) }}
        </td>
      </template>
      <template #[`item.edlc_scan_allowance`]="{ item }">
        <td class="noWrap">
          ${{ formatCurrencyDisplay(item.edlc_scan_allowance) }}
        </td>
      </template>
      <template #[`item.edlc_scan_epay_allowance`]="{ item }">
        <td class="noWrap">
          <div class="d-flex align-center" style="white-space: nowrap;">
            <span v-if="item.edlc_scan_epay_allowance !== 'N/A'">${{ formatCurrencyDisplay(item.edlc_scan_epay_allowance) }}</span>
            <span v-else>N/A</span>
            <v-tooltip 
              v-if="item.edlc_scan_epay_allowance && item.edlc_scan_epay_allowance !== 'N/A' && item.edlc_scan_epay_allowance > 0 && $auth.tenant === 'alliance-retail-group'"
              top>
              <template #activator="{ on }">
                <v-icon 
                  v-on="on" 
                  color="blue" 
                  small 
                  class="ml-1"
                  @mouseenter="loadPromotionData(item, 'edlc_scan_epay')">
                  mdi-information
                </v-icon>
              </template>
              <div>
                <span class="font-weight-bold">EDLC Scan ePay</span>
                <br>
                <span v-if="loadingPromoPrice && selectedPromotionCategory === 'edlc_scan_epay' && selectedPromotionItem === item">Loading promotion data...</span>
                <span v-else-if="promoPromotionPriceData && promoPromotionPriceData.promotion_price && selectedPromotionCategory === 'edlc_scan_epay' && selectedPromotionItem === item">
                  Promotion Price: ${{ formatCurrencyDisplay(promoPromotionPriceData.promotion_price) }}
                </span>
                <span v-else-if="selectedPromotionCategory === 'edlc_scan_epay' && selectedPromotionItem === item">No promotion price found</span>
                <span v-else>Hover to load promotion data</span>
              </div>
            </v-tooltip>
          </div>
        </td>
      </template>
      <template #[`item.edlc_scan_compete_allowance`]="{ item }">
        <td class="noWrap">
          <div class="d-flex align-center" style="white-space: nowrap;">
            <span v-if="item.edlc_scan_compete_allowance !== 'N/A'">${{ formatCurrencyDisplay(item.edlc_scan_compete_allowance) }}</span>
            <span v-else>N/A</span>
            <v-tooltip 
              v-if="item.edlc_scan_compete_allowance && item.edlc_scan_compete_allowance !== 'N/A' && item.edlc_scan_compete_allowance > 0 && $auth.tenant === 'alliance-retail-group'"
              top>
              <template #activator="{ on }">
                <v-icon 
                  v-on="on" 
                  color="blue" 
                  small 
                  class="ml-1"
                  @mouseenter="loadPromotionData(item, 'edlc_scan_compete')">
                  mdi-information
                </v-icon>
              </template>
              <div>
                <span class="font-weight-bold">EDLC Scan Compete</span>
                <br>
                <span v-if="loadingPromoPrice && selectedPromotionCategory === 'edlc_scan_compete' && selectedPromotionItem === item">Loading promotion data...</span>
                <span v-else-if="promoPromotionPriceData && promoPromotionPriceData.promotion_price && selectedPromotionCategory === 'edlc_scan_compete' && selectedPromotionItem === item">
                  Promotion Price: ${{ formatCurrencyDisplay(promoPromotionPriceData.promotion_price) }}
                </span>
                <span v-else-if="selectedPromotionCategory === 'edlc_scan_compete' && selectedPromotionItem === item">No promotion price found</span>
                <span v-else>Hover to load promotion data</span>
              </div>
            </v-tooltip>
          </div>
        </td>
      </template>
      <template #[`item.unit_cost`]="{ item }">
        <td class="noWrap">${{ formatCurrencyDisplay(item.unit_cost) }}</td>
      </template>
      <template #[`item.net_unit_cost`]="{ item }">
        <td class="noWrap">${{ formatCurrencyDisplay(item.net_unit_cost) }}</td>
      </template>
      <template v-slot:item.gross_profit="{ item }">
        {{ item.gross_profit != null ? item.gross_profit.toFixed(2) + '%' : '' }}
      </template>
      <template #[`item.net_gross_profit`]="{ item }">
        <td class="noWrap">{{ item.net_gross_profit | format }}%</td>
      </template>
      <template #[`item.retail_price`]="{ item }">
        <td class="noWrap">${{ formatCurrencyDisplay(item.retail_price) }}</td>
      </template>
      <template #[`item.obxi`]="{ item }">
        <td class="noWrap">{{ item.obxi }}</td>
      </template>
      <template #[`item.like_code`]="{ item }">
        <td class="noWrap">{{ item.like_code }}</td>
      </template>
      <template #[`item.linked_group`]="{ item }">
        <td class="noWrap">
          <span 
            v-if="item.linked_group && showLinkedGroupLink" 
            class="primary--text cursor-pointer text-decoration-underline"
            @click="filterByLinkedGroup(item.linked_group)"
            :title="`Filter by Linked Group: ${item.linked_group}`">
            {{ item.linked_group }}
          </span>
          <span v-else>{{ item.linked_group || '' }}</span>
        </td>
      </template>
      <template #[`item.start_dt`]="{ item }">
        <td class="noWrap">{{ formatDateDisplay(item.start_dt) }}</td>
      </template>
      <template #[`item.end_dt`]="{ item }">
        <td class="noWrap">{{ formatDateDisplay(item.end_dt) }}</td>
      </template>
      <template #[`item.rules_promotion_price`]="{ item }">
        <td class="noWrap" v-if="item.rules_promotion_price">
          ${{ formatCurrencyDisplay(item.rules_promotion_price) }}
        </td>
      </template>
      <template #[`item.original_promotion_price`]="{ item }">
        <td class="noWrap" v-if="item.original_promotion_price">
          ${{ formatCurrencyDisplay(item.original_promotion_price) }}
        </td>
      </template>
      <template #[`item.promotion_price`]="{ item, index }">
        <td class="px-2">
          <v-row class="my-1 px-0">
            <v-col :cols="tprProTenants ? 3 : 4" 
              class="pa-0 flex-grow-0" >
              <v-text-field
                v-if="!tprProTenants"
                :background-color="srpAndMultColor(item)"
                dense
                outlined
                hide-details
                solo
                type="number"
                @change="multiplierUpdate(item, item.multiplier); blurActiveElement()"
                @input="updateGrossProfit(item)"
                :disabled="isEditingDisabled || tprProTenants && item.excluded !== ''"
                v-model.number="item.multiplier">
              </v-text-field>
              <v-text-field v-else @input="handleInput(item, { target: { value: $event } }, 'multiplier')" dense outlined
                hide-details solo type="number" :disabled="isEditingDisabled || tprProTenants && item.excluded !== ''"
                :background-color="srpAndMultColor(item)"
                :value="item.multiplier">
              </v-text-field>
            </v-col>
            <v-icon size="20" class="px-2">mdi-at</v-icon>
            <v-col class="pa-0 flex-grow-1">
              <v-tooltip :disabled="!showComplianceTooltip(item)" top>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-if="!tprProTenants"
                    :readonly="hasSelections"
                    :rules="srpRules"
                    v-on="on"
                    prefix="$"
                    :background-color="srpAndMultColor(item)"
                    class="px-0"
                    dense
                    outlined
                    hide-details
                    solo
                    step=".01"
                    type="number"
                    v-model.number="item.promotion_price"
                    @input="updateGrossProfit(item)"
                    @blur="handleSRPBlur(item, $event)"
                    @change="srpUpdate(item, item.promotion_price); blurActiveElement()"
                    v-bind="{'data-row': index, 'data-field': 'srpInput'}"
                    @keydown.enter="handleEnterKey(index, 'srpInput', $event)"
                    :disabled="isEditingDisabled || tprProTenants && item.excluded !== ''">
                  </v-text-field>
                  <v-text-field
                    v-else
                    :readonly="hasSelections"
                    :rules="srpRules"
                    :value="item.promotion_price"
                    @input="handleInput(item, {target: {value: $event}}, 'promotion_price')"
                    @blur="handleSRPBlur(item, $event)"
                    v-bind="{'data-row': index, 'data-field': 'srpInput'}"
                    @keydown.enter="handleEnterKey(index, 'promotion_price', $event)"
                    v-on="on"
                    data-field="promotion_price"
                    prefix="$"
                    :background-color="srpAndMultColor(item)"
                    class="px-0"
                    dense
                    outlined
                    hide-details
                    solo
                    step=".01"
                    type="number"
                    :disabled="isEditingDisabled || tprProTenants && item.excluded !== ''">
                  </v-text-field>
                </template>
                <span>{{ getNonComplianceTooltip(hasSelections, item) }}
                </span>
              </v-tooltip>
            </v-col>
            <v-col class="pa-0 flex-grow-0">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn 
                    v-if="tprProTenants"
                    :style="{ visibility: item.linked_group != null && !isEditingDisabled ? 'visible' : 'hidden' }"
                    :disabled="(!isTprProRetailUser && !srpIsCompliant(item)) || (tprProTenants && item.excluded !== '')"
                    class="mt-5"
                    v-on="on"
                    x-small
                    icon
                    @click="showLinkedGroupModal(item)">
                    <v-icon color="blue darken-2">mdi-alpha-l-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>Apply SRP to ALL Linked Group items</span>
              </v-tooltip>
            </v-col>
            <v-col class="pa-0 flex-grow-0">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                <v-btn
                  v-if="tprProTenants"
                  @click="resetRow(item)"
                  icon
                  v-on="on"
                  :style="{ visibility: changes.some(change => change.id === item.id) ? 'visible' : 'hidden' }">
                  <v-icon>mdi-refresh-circle</v-icon>
                </v-btn>
                </template>
                <span>Reset Values</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </td>
      </template>
      <template #[`item.total_allowance_per_unit`]="{ item }">
        <td class="noWrap">${{ Number(item.total_allowance_per_unit).toFixed(2) }}</td>
      </template>
      <template #[`item.srp_needed_to_maintain_margin`]="{ item }">
        <td class="noWrap">${{ Number(item.srp_needed_to_maintain_margin).toFixed(2) }}</td>
      </template>
      <template #[`item.difference_to_regular_price`]="{ item }">
        <td class="noWrap" :class="{ 'red--text': calculateDifferenceToRegularPrice(item) > 0 }">
          ${{ calculateDifferenceToRegularPrice(item).toFixed(2) }}
        </td>
      </template>
      <template #[`item.prev_msu`]="{ item }">
        <td class="noWrap">{{ item.prev_msu || '---' }}</td>
      </template>
      <template #[`item.prev_retail`]="{ item }">
        <td class="noWrap">{{ item.prev_retail ? `$${formatCurrencyDisplay(item.prev_retail)}` : '---' }}</td>
      </template>
      <template #[`item.prev_margin`]="{ item }">
        <td class="noWrap">{{ item.prev_margin ? `${item.prev_margin}%` : '---' }}</td>
      </template>
      <template #[`item.prev_net_unit_cost`]="{ item }">
        <td class="noWrap">{{ item.prev_net_unit_cost ? `$${formatCurrencyDisplay(item.prev_net_unit_cost)}` : '---' }}</td>
      </template>
      <template #[`item.previous_tpr_cost`]="{ item }">
        <td class="noWrap">{{ item.previous_tpr_cost ? `$${formatCurrencyDisplay(item.previous_tpr_cost)}` : '---' }}</td>
      </template>
      <template #[`item.previous_tpr_msu`]="{ item }">
        <td class="noWrap">{{ item.previous_tpr_msu || '---' }}</td>
      </template>
      <template #[`item.previous_tpr_retail`]="{ item }">
        <td class="noWrap">{{ item.previous_tpr_retail ? `$${formatCurrencyDisplay(item.previous_tpr_retail)}` : '---' }}</td>
      </template>
      <template #[`item.previous_tpr_margin`]="{ item }">
        <td class="noWrap">{{ item.previous_tpr_margin ? `${item.previous_tpr_margin}%` : '---' }}</td>
      </template>
      <template #[`item.current_tpr_msu`]="{ item }">
        <td class="noWrap">{{ item.current_tpr_msu || '---' }}</td>
      </template>
      <template #[`item.current_tpr_retail`]="{ item }">
        <td class="noWrap">{{ item.current_tpr_retail ? `$${formatCurrencyDisplay(item.current_tpr_retail)}` : '---' }}</td>
      </template>
      <template #[`item.current_tpr_end_date`]="{ item }">
        <td class="noWrap">{{ item.current_tpr_end_date ? formatDateDisplay(item.current_tpr_end_date) : '---' }}</td>
      </template>
      <template #[`item.length_of_tpr`]="{ item }">
        <td class="noWrap">{{ item.length_of_tpr ? `${item.length_of_tpr} days` : '---' }}</td>
      </template>
      <template #[`item.comp_pricing_mode`]="{ item }">
        <td class="noWrap"  v-if="item.comp_pricing_mode !== 'N/A'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="tprProTenants" v-bind="attrs" v-on="on" :color="getPriceComparisonColor(item)">
                {{ getPriceComparisonIcon(item) }}
              </v-icon>
            </template>
            <span>{{ getPriceComparisonText(item) }}</span>
          </v-tooltip>
        </td>
        <td>
          <span v-if="item.comp_pricing_mode !== 'N/A'">${{ formatCurrencyDisplay(item.comp_pricing_mode) }}</span>
          <span v-else>N/A</span>
        </td>
      </template>
      <template #[`item.promo_info`]="{ item }">
        <v-menu :close-on-content-click="false" offset-x offset-y open-on-click right>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip top>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn @click="getPromosByRow(item)" color="primary" icon tabindex="-1" v-bind="attrs"
                  v-on="{ ...tooltip, ...menu }">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>View Promos</span>
            </v-tooltip>
          </template>
          <v-card width="400">
            <v-toolbar flat class="accent" dark>
              <v-toolbar-title>Included in Allowances</v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-container fluid class="ma-0 pa-0" style="max-height: 250px; overflow-y: auto">
              <v-list class="py-0" dense>
                <v-list-item v-for="promo in promosByRow" :key="promo.promo_id" link @click="openLink(promo.promo_id)">
                  <v-list-item-content class="primary--text">
                    <v-list-item-title>{{
                      promo.promo_name
                      }}</v-list-item-title>
                    <template v-if="promosByRow.length > 0">
                      <v-list-item-subtitle>{{ promo.promo_number }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="$auth.tenant === 'awg'">
                        {{ formatDateDisplay(promo.promo_start_date) }} - {{ formatDateDisplay(promo.promo_end_date) }}
                      </v-list-item-subtitle>
                    </template>
                    <template v-else>
                      <v-list-item-subtitle>No Promos to Show</v-list-item-subtitle>
                    </template>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-container>
          </v-card>
        </v-menu>
      </template>
      <template v-if="tenant=='alliance-retail-group'" #[`item.is_shipper`]="{ item }">
        <span v-if="item.is_shipper">
          <v-btn icon color="primary" @click.stop="selectedItem = item; showComponents = true">
            <v-icon>mdi-view-list</v-icon>
          </v-btn>
        </span>
      </template>
      <template #item.data-table-expand="{item, isExpanded}">
        <v-icon
          :color="retailMatchesAcrossStores(item) ? 'black' : 'red'"
          @click="handleExpansion(item, isExpanded)"
        >{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </template>
      <!-- As of right now, Store users dont get a Note field -->
      <template v-if="!isTprProRetailUser" #expanded-item="{ item, headers }">
        <td :colspan="headers.length" class="grey lighten-3 pa-0">
          <v-text-field tabindex="-1" background-color="grey lighten-3" color="primary" dense flat hide-details
            placeholder="Add Note" v-model="item.note" @change="noteUpdate(item)">
            <template #prepend-inner>
              <label class="font-weight-medium mx-3 pt-1">Note:</label>
            </template>
          </v-text-field>
        </td>
      </template>
      <template v-else-if="isTprProRetailUser" #expanded-item="{ item, headers }">
        <BatchItemAlternateStores
          :headers="headers"
          :alternateStoreItems="item.alternate_store_items">
        </BatchItemAlternateStores>
      </template>
      <template #footer>
        <v-divider></v-divider>
        <v-toolbar flat color="#fff" style="margin-top: 16px; height: 56px;">
          <v-row class="align-center" style="height: 100%;">
            <v-spacer />
            <v-col cols="2" class="d-flex align-center py-0" style="max-width: 150px;">
              <v-select :items="pageSizes" :menu-props="{
                top: true,
                offsetY: true,
                maxHeight: 500
                }" dense height="32" label="Items Per Page" v-model="pageSize">
              </v-select>
            </v-col>
            <v-col cols="auto" class="d-flex align-center py-0" style="margin-top: -26px;">
            <v-btn :disabled="disablePrevious" @click="previous" class="mx-2" icon large>
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <small>Page {{ page }}</small>
            <v-btn :disabled="disableNext" @click="next" class="mx-2" icon large>
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>
    </template>
    </v-data-table>
    <v-dialog v-model="showConfirmPopup" persistent width="400">
      <v-card class="modalCard" height="220">
        <v-toolbar flat dark class="main">
          <v-toolbar-title>Confirm SRP Values</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <!-- Single Column Wrapping All Rows -->
          <v-col>
            <!-- Checkbox Section -->
            <v-row class="align-center">
              <v-checkbox
                id="checkbox"
                v-model="confirmChecked"
                label="I understand that I am saving items with an SRP value that falls outside of the compliance range."
                hide-details
              ></v-checkbox>
            </v-row>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center">
            <v-col cols="auto">
              <v-btn @click="cancelConfirm">Cancel</v-btn>
              <v-btn
                class="ml-3 green white--text"
                :disabled="!confirmChecked"
                @click="saveChanges"
              >
              Confirm Save
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <StoreGroupModal
      :value.sync="storeGroupModal"
      :userStores="userStores"
      :storeParty="selectedStoreParty">
    </StoreGroupModal>
    <AlertDialog :value.sync="alertDialog" :batch="selectedBatch" :total="total" @update="batchUpdate($event)" />
    <AdGroupShuttle :value.sync="adShuttleDialog" :ad_group="selectedAdGroup" :batch="selectedBatch" :batch_changes="changesAvailableForShuttle"/>
    <LinkedGroupModal 
      v-if="linkedGroupModal"
      :value.sync="linkedGroupModal" 
      :item="linkedGroupItem" 
      :batch="selectedBatch" 
      :store="selectedStore"
      :isTprProRetailUser="isTprProRetailUser"
      @onSave="linkedGroupUpdated">
    </LinkedGroupModal>
    <v-overlay absolute :value="exporting">
      <v-progress-circular indeterminate size="100">
        Exporting...
      </v-progress-circular>
    </v-overlay>
    <ComponentItems
      v-if="showComponents"
      v-model="showComponents"
      @close="showComponents = false"
      :selectedItem="selectedItem"
      :selectedBatch="selectedBatch"
    />
  </v-container>
</template>
<script>
import Items from '@/axios/items'
import Rules from '@/axios/rules-management.js'
import { retryApiCall } from '@/store/index.js'
import { fullwidth } from '@/mixins/fullwidth'
import { paging } from '@/mixins/paging'
import { displayHelpers } from '@/mixins/displayHelpers'
import { userAccess } from '@/mixins/user-access'
import { utils } from '@/mixins/utils'
import { shared } from '@/mixins/shared'
import StoreGroupModal from '@/components/StoreGroupModal.vue'
import SearchFilters from '@/components/SearchFilters.vue'
import ComponentItems from '@/components/ComponentItems.vue'
import Draggable from 'vuedraggable'
import AdGroupShuttle from '@/components/AdGroupShuttle.vue'
import LinkedGroupModal from '@/components/LinkedGroupModal.vue'
import BatchItemAlternateStores from '@/components/BatchItemAlternateStores.vue'
export default {
  name: 'BatchView',
  components: { SearchFilters, ComponentItems, Draggable, LinkedGroupModal, BatchItemAlternateStores, StoreGroupModal },
  mixins: [fullwidth, displayHelpers, paging, userAccess, utils, shared, AdGroupShuttle],
  data() {
    return {
      actionMenu: false,
      infoMenu: false,
      sessionMenu: false,
      storeGroupModal: false,
      adShuttleDialog: false,
      selectedAdGroup: {},
      categoryList: [],
      subcategoryList: [],
      confirmChecked: false,
      changesAvailableForShuttle: [],
      selectedStore: {},
      selectedStoreParty: {},
      deleteMenu: false,
      departmentList: [],
      promoCategoryList: [],
      vendorList: [],
      expanded: [],
      items: [],
      fullMultiStoreItems: [],
      linkedGroupModal: false,
      loading: true,
      multiplier: '',
      displayHeaders: [],
      hideHeaders: [],
      search: '',
      searchMenu: false,
      searchValues: [],
      searchParams: {},
      selectedRow: {},
      selected: [],
      sortBy: [],
      sort: null,
      showConfirmPopup: false,
      showRemoveSortsButton: false,
      showModal: false,
      showComponents: false,
      selectedHeaders: [],
      selectedItem: {},
      srp: '',
      srprefresh: 0,
      srpMenu: false,
      tprDate: '',
      tprEndDate: '',
      changes: [],
      originalItems: [],
      banners: [],
      selectedPromotionItem: null,
      selectedPromotionCategory: '',
      selectedPromotionAllowance: 0,
      promoPromotionPriceData: null,
      loadingPromoPrice: false,
      sessionRestoreShown: false,
      savedStateBeforeFilters: null,
      isRestoringState: false,
      truncateAt: 25,
      showExpanded: false,
      requestSequence: 0,
      activeRequestId: 0,
      isSessionRestoring: false,
      linkedGroupItem: null
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasActiveChanges) {
      if (confirm('You have unsaved changes. Do you want to discard changes?')) {
        this.changes = []
        localStorage.removeItem(`changes_${this.selectedBatch.id}`)
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  created() {
      this.nonTableHeight = 240
      this.loadUserHeaders()
      this.initializeBatchView()
  },
  mounted() {
    this.loadUserHeaders()
    this.loadUniqueValues()
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    this.$root.$on("shuttleWholeBatch", this.handleShuttleWholeBatch);
  },
  watch: {
    'selectedBatch.status'(newStatus) {
      if (newStatus === 'PUBLISHED') {
        this.alert('This batch is published and cannot be modified.')
      }
    },
    'selectedStore.is_price_pro_store'(newValue) {
      if (this.isTprProRetailUser && newValue === false) {
        this.alert('This store is not a Price Pro store and cannot be modified.')
      }
    },
    srpMenu: {
      handler(newValue) {
        if (newValue === false) {
          this.$refs.form.reset()
        }
      }
    },
    searchMenu: {
      handler(newValue) {
        if (newValue === false) {
          this.$refs.form.reset()
        }
      }
    },
    searchValues: {
      handler(newValue, oldValue) {
        sessionStorage.setItem(
          'tpr_manager_item_search',
          JSON.stringify(newValue)
        )
        if (this.isSessionRestoring) {
          return
        }
        if (newValue.length !== oldValue.length) {
          this.page = 1
          this.loadItems()
        }
      }
    },
    searchParams: {
      handler (newValue, oldValue) {
        if (this.isSessionRestoring) {
          return
        }
        if (newValue) {
          // Save state before applying filters (only if no filters were previously applied)
          const hadFilters = oldValue && Object.keys(oldValue).some(key => {
            const value = oldValue[key]
            return Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== ''
          })
          const hasFilters = this.hasFiltersApplied()
          // Save state before first filter is applied
          if (!hadFilters && hasFilters) {
            this.saveStateBeforeFilters()
          }
          // Restore state when all filters are removed
          if (hadFilters && !hasFilters) {
            this.isRestoringState = true
            this.restoreStateAfterFiltersRemoved()
            return // Skip the page reset below during restoration
          }
          // Don't reset page to 1 if we're in the middle of restoring state
          if (this.page > 1 && !this.isRestoringState) {
            this.page = 1
          }
        }
      },
      deep: true
    },
    sortBy(newVal) {
      this.showRemoveSortsButton = newVal.length > 0 // Show button if sortBy length is greater than 1
    },
    changes: {
      handler(newValue) {
        if (newValue) {
          localStorage.setItem(`changes_${this.selectedBatch.id}`, JSON.stringify(newValue))
        }
      },
      deep: true,
    },
    page: {
      handler(newValue) {
        this.onPageChanged(newValue)
      }
    },
  },
  computed: {
    isPublished() {
      return this.selectedBatch.status === 'PUBLISHED'
    },
    isEditingDisabled() {
      if (this.isReadOnlyAdmin) return true
      // Disable editing if batch is published
      if (this.isPublished) return true
      // Disable editing for TPR Pro retail users viewing non-Price Pro stores
      if (this.isTprProRetailUser && this.selectedStore && this.selectedStore.is_price_pro_store === false) return true
      return false
    },
    hasInvalidInputs() {
      return this.changes.some(change => {
        const item = this.items.find(i => i.id === change.id) || this.originalItems.find(i => i.id === change.id)
        const promotion_price = change.promotion_price !== undefined ? change.promotion_price : item.promotion_price
        const multiplier = change.multiplier !== undefined ? change.multiplier : item.multiplier
        return promotion_price <= 0 || multiplier <= 0 || (this.isTprProRetailUser && !this.passPercentIsCompliant(item)) ||(this.blockNonCompliantSaves && !this.srpIsCompliant(item))
      })
    },
    hasActiveChanges() {
      return this.changes.length > 0
    },
    tprProTenants() {
      return this.$auth.tenant === 'alliance-retail-group'
    },
    blockNonCompliantSaves() {
      return this.tprProTenants && !this.isTprProRetailUser
    },
    userEmail() {
      return this.$auth.user.email
    },
    promosByRow() {
      return this.selectedRow ? this.selectedRow.promos : []
    },
    promotionCategoryDisplay() {
      if (this.selectedPromotionCategory === 'tpr_scan_epay') {
        return 'TPR Scan ePay'
      } else if (this.selectedPromotionCategory === 'tpr_scan_compete') {
        return 'TPR Scan Compete'
      }
      return this.selectedPromotionCategory
    },
    isFiltered() {
      return this.searchValues.length > 0 ? this.searchValues.length > 0 : false
    },
    hasActiveFilters() {
      return this.hasFiltersApplied()
    },
    hasSelections() {
      return this.selected.length > 0
    },
    breadcrumbs() {
      const tprDateFormatted = this.moment(this.tprDate).format(
        this.$dateConfig.date_display
      )
      return [
        {
          text: this.selectedAdGroup.name || this.selectedStore.store_name,
          exact: true,
          href: '/',
        },
        {
          text: this.selectedBatch?.batch_name
            ? `${this.formatName(this.selectedBatch.batch_name)} (${tprDateFormatted})`
            : tprDateFormatted,
          expanded_text: this.selectedBatch?.batch_name
            ? `${this.selectedBatch.batch_name} (${tprDateFormatted})`
            : tprDateFormatted,
          exact: true,
          disabled: true,
        }
      ]
    },
    getBannerPrices() {
      return (item) => {
        if (!item.comp_pricing) return {}
        try {
          const parsedPricing = JSON.parse(item.comp_pricing)
          return parsedPricing.reduce((acc, banner) => {
            acc[banner.banner] = banner.regular_price_mode || 0
            return acc
          }, {})
        } catch (e) {
          console.error('Failed to parse comp_pricing:', e)
          return {}
        }
      }
    },
    disablePrevious() {
      return (this.page - 1) * this.pageSize === 0
    },
    disableNext() {
      return this.items.length < this.pageSize
    },
    srpRules() {
      const rules = []
      const valueRequired = v => !!v || 'SRP Required'
      rules.push(valueRequired)
      const positiveValue = v => parseFloat(v) >= 0 || 'Invalid SRP'
      rules.push(positiveValue)
      return rules
    },
    multiplierRules() {
      const rules = []
      const valueRequired = v => !!v || 'Multiplier Required'
      rules.push(valueRequired)
      const positiveValue = v => v > 0 || 'Invalid Multiplier'
      rules.push(positiveValue)
      return rules
    },
    storeGroupSelected() {
      return this.useStoreParties && this.selectedStoreParty?.party_type === 'TPR_STORE_GROUP'
    },
    useStoreParties() {
      return this.isTprProRetailUser && this.$auth.tenant === 'alliance-retail-group'
    },
    isTprProRetailUser() {
      return this.userGroups.includes('tpr-manager.pro') || this.userGroups.includes('tpr-manager.retailer')
    },
    hasWarnings() {
      return this.toolbarWarnings.length > 0
    },
    toolbarWarnings() {
      let warnings = []
      if (this.hasActiveChanges) {
        warnings.push({type: "warning", message: "Warning: Please save changes before leaving Batch View."})
      }
      if (this.isEditingDisabled && this.isTprProRetailUser && this.selectedStore && this.selectedStore.is_price_pro_store === false) {
        warnings.push({type: "info", message: "Info: This store is not a Price Pro store and cannot be modified."})
      }
      if (this.isPublished) warnings.push({type: "info", message: "Info: This batch is published and cannot be modified."})
      return warnings
    },
    toolbarWarningsColor() {
      if (this.toolbarWarnings.length == 0) return ''
      if (this.toolbarWarnings.some(alert => alert.type === 'warning')) return "orange"
      else return "blue"
    },
    showLinkedGroupLink() {
      return [].includes(this.$auth.tenant)
    },
    allHeaders() {
      let headers
      if (this.$auth.tenant === 'alliance-retail-group') {
        headers = [
          { sortable: false, class: 'accent', value: 'data-table-select', text: 'Checkbox', default_show: true },
          { text: 'Included', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'excluded', default_show: true },
          { text: 'Compliance Enforced', align: 'center', sortable: true, class: 'accent white--text', value: 'enforce_compliance', default_show: true },
          { text: 'Item ID', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'item_id', default_show: true },
          { text: 'Description', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'description', default_show: true },
          { text: 'UPC', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'upc', default_show: true },
          { text: 'Pack', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'qty_per_case', default_show: true },
          { text: 'Size', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'pack_size', default_show: true },
          { text: 'Department', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'department', default_show: true },
          { text: 'Case Cost/FRT', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'case_freight', default_show: true },
          { text: 'TPR Scan', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'tpr_scan_allowance', default_show: true },
          { text: 'TPR Scan ePay', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'tpr_scan_epay_allowance', default_show: true },
          { text: 'TPR Scan Compete', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'tpr_scan_compete_allowance', default_show: true },
          { text: 'AMAP', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'amap_allowance', default_show: true },
          { text: 'DSD OI', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'dsd_oi_allowance' },
          { text: 'TPR Billback', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'tpr_billback_allowance', default_show: true },
          { text: 'Reg Unit Cost/FRT', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'unit_cost', default_show: true },
          { text: 'Reg Retail', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'retail_price', default_show: true },
          { text: 'Reg GP%', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'gross_profit', default_show: true },
          { text: 'Net Unit Cost/FRT', align: 'start', sortable: true, filterable: true, class: 'green white--text', value: 'net_unit_cost', default_show: true },
          { text: 'Original Promotion Price', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'original_promotion_price', default_show: true },
          { text: 'Rules Promotion Price', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'rules_promotion_price', default_show: true },
          { text: 'Multiplier @ SRP', align: 'center', sortable: true, filterable: true, class: 'accent white--text', value: 'promotion_price', width: '240', disabled: false, default_show: true },
          { text: 'Net GP%', align: 'start', sortable: false, filterable: false, class: 'accent white--text', value: 'net_gross_profit', default_show: true },
          { text: 'WALMART', align: 'center', sortable: true, filterable: false, class: 'green white--text', value: 'comp_pricing_WALMART', default_show: true },
          { text: 'Order Book Index', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'obxi', default_show: true },
          { text: 'Start Date', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'start_dt', default_show: true },
          { text: 'End Date', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'end_dt', default_show: true },
          { text: 'Rules Applied', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'rules_applied', default_show: true },
          { text: 'Promo Info', align: 'start', sortable: false, filterable: false, class: 'accent white--text', value: 'promo_info', default_show: true },
          { text: 'Group Manager Modified', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'group_manager_modified', default_show: false },
          { text: 'Category', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'category', default_show: false },
          { text: 'Vendor ID', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'vendor_id', default_show: false },
          { text: 'Vendor Name', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'vendor_name', default_show: false },
          { text: 'Case Cost', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'cost', default_show: false },
          { text: 'EBA', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'early_buy_allowance', default_show: false },
          { text: 'EDLC Billback', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'edlc_billback_allowance', default_show: false },
          { text: 'EDLC Scan', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'edlc_scan_allowance', default_show: false },
          { text: 'EDLC Scan ePay', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'edlc_scan_epay_allowance', default_show: false },
          { text: 'EDLC Scan Compete', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'edlc_scan_compete_allowance', default_show: false },
          { text: 'Linked Group', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'linked_group', default_show: false },
          { text: 'Like Code', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'like_code', default_show: false },
          { text: 'Components', align: 'start', sortable: false, filterable: false, class: 'accent white--text', value: 'is_shipper', default_show: false }
        ]
      } else if (this.$auth.tenant == 'awg') {
        headers = [
          { sortable: false, class: 'accent', value: 'data-table-select', text: 'Checkbox' },
          { text: 'Included', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'excluded'},
          { text: 'Department', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'department' },
          { text: 'Department #', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'department_number' },
          { text: 'Rules Applied', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'rules_applied' },
          { text: 'Category #', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'category_number' },
          { text: 'Category Description', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'category' },
          { text: 'Sub-Category #', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'subcategory_number' },
          { text: 'Sub-Category Description', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'subcategory' },
          { text: 'Linked Group', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'linked_group' },
          { text: 'UPC', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'upc' },
          { text: 'Item #', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'item_id' },
          { text: 'Item Description', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'description' },
          { text: 'Pack', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'qty_per_case' },
          { text: 'Size', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'pack_size' },
          { text: 'Case Cost', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'cost' },
          { text: 'Reg Unit Cost', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'unit_cost' },
          { text: 'Promo Info', align: 'start', sortable: false, filterable: false, class: 'accent white--text', value: 'promo_info' }, // magnifying glass
          { text: 'AMAP', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'amap_allowance' },
          { text: 'TPR Billback', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'tpr_billback_allowance' },
          { text: 'TPR Scan', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'tpr_scan_allowance' },
          { text: 'EDLC Billback', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'edlc_billback_allowance' },
          { text: 'EDLC Scan', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'edlc_scan_allowance' },
          { text: 'Total Allowance Per Unit', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'total_allowance_per_unit' },
          { text: 'Net Unit Cost', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'net_unit_cost' },
          { text: 'Multiplier @ SRP', align: 'center', sortable: true, filterable: true, class: 'accent white--text', value: 'promotion_price', width: '190', disabled: false },
          { text: 'TPR GP%', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'net_gross_profit' },
          { text: 'Compliance Enforced', align: 'center', sortable: true, filterable: true, class: 'accent white--text', value: 'enforce_compliance' },
          { text: 'SRP Needed to Maintain Margin', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'srp_needed_to_maintain_margin' },
          { text: 'Difference to Regular Price', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'difference_to_regular_price' },
          { text: 'Current Retail Price', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'retail_price' },
          { text: 'Start Date', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'start_dt' },
          { text: 'End Date', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'end_dt' },
          { text: 'Components', align: 'start', sortable: false, filterable: false, class: 'accent white--text', value: 'is_shipper' },
          { text: 'Length of TPR', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'length_of_tpr' },
          { text: 'Previous TPR - Cost', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'prev_net_unit_cost' },
          { text: 'Previous TPR - MSU', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'prev_msu' },
          { text: 'Previous TPR - Retail', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'prev_retail' },
          { text: 'Previous TPR - Margin', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'prev_margin' },
          { text: 'Current TPR - MSU', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'current_tpr_msu' },
          { text: 'Current TPR - Retail', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'current_tpr_retail' },
          { text: 'Current TPR - End Date', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'current_tpr_end_date' }
        ]
      } else {
        headers = [
          { sortable: false, class: 'accent', value: 'data-table-select', text: 'Checkbox' },
          { text: 'Department', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'department' },
          { text: 'Included', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'excluded' },
          { text: 'Group Manager Modified', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'group_manager_modified' },
          { text: 'Rules Applied', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'rules_applied' },
          { text: 'Rules Promotion Price', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'rules_promotion_price' },
          { text: 'Original Promotion Price', align: 'start', sortable: false, filterable: true, class: 'accent white--text', value: 'original_promotion_price' },
          { text: 'Category', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'category' },
          { text: 'Linked Group', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'linked_group' },
          { text: 'UPC', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'upc' },
          { text: 'Item ID', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'item_id' },
          { text: 'Description', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'description' },
          { text: 'Vendor ID', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'vendor_id' },
          { text: 'Pack', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'qty_per_case' },
          { text: 'Size', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'pack_size' },
          { text: 'Case Cost', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'cost' },
          { text: 'Case Freight', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'case_freight' },
          { text: 'Reg Unit Cost', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'unit_cost' },
          { text: 'AMAP', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'amap_allowance' },
          { text: 'EBA', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'early_buy_allowance' },
          { text: 'TPR Billback', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'tpr_billback_allowance' },
          { text: 'TPR Scan', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'tpr_scan_allowance' },
          { text: 'EDLC Billback', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'edlc_billback_allowance' },
          { text: 'EDLC Scan', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'edlc_scan_allowance' },
          { text: 'Net Unit Cost', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'net_unit_cost' },
          { text: 'Compliance Enforced', align: 'center', sortable: true, class: 'accent white--text', value: 'enforce_compliance' },
          { text: 'Multiplier @ SRP', align: 'center', sortable: true, filterable: true, class: 'accent white--text', value: 'promotion_price', width: '190', disabled: false },
          { text: 'GP%', align: 'start', sortable: true, filterable: false, class: 'accent white--text', value: 'net_gross_profit' },
          { text: 'Retail Price', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'retail_price' },
          { text: 'Order Book Index', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'obxi' },
          { text: 'Like Code', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'like_code' },
          { text: 'Start Date', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'start_dt' },
          { text: 'End Date', align: 'start', sortable: true, filterable: true, class: 'accent white--text', value: 'end_dt' },
          { text: 'Promo Info', align: 'start', sortable: false, filterable: false, class: 'accent white--text', value: 'promo_info' },
          { text: 'Components', align: 'start', sortable: false, filterable: false, class: 'accent white--text', value: 'is_shipper' }
        ]
      }
      // If there is no defined default_show field on the header, then add a default_show to true - used when loading headers for the first time or resetting
      for (let header of headers) {
        if (!('default_show' in header)) {
          header.default_show = true
        }
      }
      if (this.tprProTenants) {
        this.banners.forEach(banner => {
          const headerValue = `comp_pricing_${banner}`
          if (!headers.some(header => header.value === headerValue)) {
            headers.push({
              text: banner.replace(/_/g, ' '),
              align: 'center',
              sortable: true,
              filterable: false,
              class: 'green white--text',
              value: headerValue,
              default_show: false
            })
          }
        })
        this.banners.length > 0 && headers.push({
          text: 'Competitor Pricing Mode',
          align: 'center',
          sortable: false,
          filterable: false,
          class: 'green white--text',
          value: 'comp_pricing_mode',
          width: '75',
          default_show: false
        })
      }
      if (!this.tprProTenants) {
        headers = headers.filter(header => !['original_promotion_price',  'rules_promotion_price', 'rules_applied', 'obxi', 'like_code', 'is_shipper','comp_pricing', 'case_freight'].includes(header.value))
        if (this.$auth.tenant !== 'awg') {
          headers = headers.filter(header => !['excluded'].includes(header.value))
        }
      }
      // ARG doesn't want these headers
      if (this.$auth.tenant === 'alliance-retail-group') {
        headers = headers.filter(header => !['like_code'].includes(header.value))
      }
      let vendorIdTenants = ['alliance-retail-group', 'pricechopper']
      if (!vendorIdTenants.includes(this.$auth.tenant)) {
        headers = headers.filter(header => header.value !== 'vendor_id')
      }
      // store users hide rules promo price and promo info.
      if (this.isTprProRetailUser) {
        headers = headers.filter(header => !['rules_promotion_price', 'promo_info'].includes(header.value))
      }
      if (!this.isTprProRetailUser || !this.tprProTenants) {
        headers = headers.filter(header => !['group_manager_modified'].includes(header.value))
      }
      return headers
    },
  },
  methods: {
    retailMatchesAcrossStores(item) {
      let match = true
      item.alternate_store_items.forEach(altItem => {
        if (altItem.retail_price !== item.retail_price || altItem.promotion_price !== item.promotion_price) match = false
      })
      return match
    },
    handleExpansion(item, state) {
      const itemIndex = this.expanded.indexOf(item);
      state ? this.expanded.splice(itemIndex, 1) : this.expanded.push(item);
    },
    initializeBatchView() {
      if(!this.isTprProRetailUser) {
        this.tableChanged = this.tableChange(this.getItems, this.storeGroupSelected)
        const savedChanges = localStorage.getItem(`changes_${this.selectedBatch.id}`)
        if (savedChanges) {
          this.changes = JSON.parse(savedChanges)
        }
        this.cleanupOtherBatchChanges()

        const { ad_group, tpr_date, tpr_end_date, selected_batch } = this.$route.params
        const {
          tpr_manager_ad_group,
          tpr_manager_tpr_date,
          tpr_manager_tpr_end_date,
          tpr_manager_selected_batch,
          tpr_manager_item_search
        } = sessionStorage

        this.selectedAdGroup = ad_group || JSON.parse(tpr_manager_ad_group)
        this.tprDate = tpr_date || tpr_manager_tpr_date || sessionStorage.getItem('selected_batch_tpr_date')
        this.tprEndDate = tpr_end_date || tpr_manager_tpr_end_date
        this.selectedBatch =
          selected_batch || JSON.parse(tpr_manager_selected_batch)
        this.searchValues = tpr_manager_item_search
          ? JSON.parse(tpr_manager_item_search)
          : []

        sessionStorage.setItem('selected_batch_tpr_date', this.tprDate)
        this.getItems()
        this.tableChanged = this.tableChange(this.getItems)
      } else {
        this.tableChanged = this.tableChange(this.getItems, this.storeGroupSelected)
        const savedChanges = localStorage.getItem(`changes_${this.selectedBatch.id}`)
        if (savedChanges) {
          this.changes = JSON.parse(savedChanges)
        }
        this.cleanupOtherBatchChanges()
        const { store, store_party, tpr_date, tpr_end_date, selected_batch, user_stores } = this.$route.params
        const {
          tpr_pro_store,
          tpr_manager_tpr_date,
          tpr_manager_tpr_end_date,
          tpr_manager_selected_batch,
          tpr_manager_item_search
        } = sessionStorage
        this.selectedStore = store || JSON.parse(tpr_pro_store)
        if (this.useStoreParties) { 
          this.selectedStoreParty = store_party
          this.userStores = user_stores
        }
        this.tprDate = tpr_date || tpr_manager_tpr_date || sessionStorage.getItem('selected_batch_tpr_date')
        this.tprEndDate = tpr_end_date || tpr_manager_tpr_end_date
        this.selectedBatch =
          selected_batch || JSON.parse(tpr_manager_selected_batch)
        this.searchValues = tpr_manager_item_search
          ? JSON.parse(tpr_manager_item_search)
          : []

        sessionStorage.setItem('selected_batch_tpr_date', this.tprDate)
        this.getItems()
        this.tableChanged = this.tableChange(this.getItems, this.storeGroupSelected)
      }
    },
    loadItems() {
      this.getItems()
      // Ensure header indicators are always in sync after loading
      this.$nextTick(() => {
        this.updateHeaderSortIndicators()
      })
    },
    async getItems() {
      const requestId = ++this.requestSequence
      this.activeRequestId = requestId
      this.loading = true
      const sortString = this.sortBy
        .map(([column, order]) => `${column} ${order}`)
        .join(', ')
      const params = {
        ...this.searchParams,
        tpr_date: this.tprDate,
        sort_by: sortString
      }
      try {
        // determine batch ID and store ID based on user type
        const batchId = this.isTprProRetailUser ? this.selectedBatch.tpr_batch_id : this.selectedBatch.id
        if (this.isTprProRetailUser) params.store_ids = this.useStoreParties ? this.selectedStoreParty.children.flatMap(p => p.party_id) : this.selectedStore.store_party_id
        const { data } = await (this.isTprProRetailUser ? retryApiCall(() =>
          Items.getItems(batchId, params, this.pageSize, this.from)
        ) : Items.getItems(batchId, params, this.pageSize, this.from))
        if (requestId !== this.activeRequestId) {
          return
        }
        this.formatAllSRPValues(data)
        // Collect all distinct banners
        let allBanners = this.extractBanners(data)
        // Add distinct banners to banners array
        allBanners.forEach(banner => {
          if (!this.banners.includes(banner)) {
            this.banners.push(banner)
          }
        })
        let banners = this.banners
        const updatedItems = data.map(item => {
          const changedItem = this.changes.find(change => change.id === item.id)
          let updatedItem = {
            ...item,
            ...changedItem,
            srp: changedItem?.srp || this.computedPromotionPrice({ ...item, ...changedItem })
          }
          updatedItem.srp = this.computedPromotionPrice(updatedItem)
          // Add comp_pricing_(banner) fields
          const bannerPrices = this.getBannerPrices(item)
          banners.forEach(banner => {
            const price = bannerPrices[banner.replace(/_/g, ' ')]
            updatedItem[`comp_pricing_${banner}`] = price ? parseFloat(price).toFixed(2) : 'N/A'
          })
          // add mode of comp_pricing columns to item
          const validPrices = banners.map(banner => parseFloat(this.getBannerPrice(item.comp_pricing, banner.replace(/_/g, ' ')))).filter(price => !isNaN(price) && price !== 0)
          if (validPrices.length === 1) {
            updatedItem.comp_pricing_mode = validPrices[0].toFixed(2)
          } else if (validPrices.length >= 2) {
            const priceCounts = validPrices.reduce((acc, val) => {
              acc[val] = (acc[val] || 0) + 1
              return acc
            }, {})
            const modePrice = Object.keys(priceCounts).reduce((a, b) => priceCounts[a] > priceCounts[b] ? a : b)
            if (priceCounts[modePrice] === 1) {
              updatedItem.comp_pricing_mode = Math.min(...validPrices).toFixed(2)
            } else {
              updatedItem.comp_pricing_mode = parseFloat(modePrice).toFixed(2)
            }
          } else if (validPrices.length > 0) {
            const lowestPrice = Math.min(...validPrices)
            updatedItem.comp_pricing_mode = lowestPrice.toFixed(2)
          } else {
            updatedItem.comp_pricing_mode = 'N/A'
          }
          if (this.useStoreParties) {
            const alternateStoreItems = data.filter(altItem => altItem.item_id === item.item_id && altItem.store_id !== item.store_id )
            updatedItem.alternate_store_items = alternateStoreItems.sort((a, b) => a - b)
          }
          return updatedItem
        })
        if (this.storeGroupSelected) {
          this.fullMultiStoreItems = updatedItems.filter(item => item.store_id === this.selectedStore.store_id)
          const offset = (this.page - 1) * this.pageSize
          this.items = this.fullMultiStoreItems.slice(offset, offset + this.pageSize)
        } else {
          this.items = updatedItems
        }

        // Recalculate Net GP% from the displayed TPR SRP (promotion_price) for ARG
        // ad-group users on unedited items. The DB-stored net_gross_profit may have
        // been calculated from rules_promotion_price by the batch generation pipeline,
        // causing a mismatch with the SRP shown in the UI.
        if (!this.isTprProRetailUser && this.tprProTenants) {
          for (const item of this.items) {
            if (item.version_id === 1 && item.rules_applied) {
              item.net_gross_profit = await this.calculateGrossProfit(item)
            }
          }
        }

        await this.preloadEnforcedPromos()
        if (!this.isTprProRetailUser) this.expanded = this.items
        if (sortString.length === 0) {
          this.loadUserHeaders()
        }
      } catch (err) {
        if (requestId === this.activeRequestId) {
          console.error(err)
          const message = err?.response?.data?.message || err.message
          this.alert(`No Matching Items Found: ${message}`)
        } else {
          console.debug('Discarded stale batch items response', err)
        }
      } finally {
        if (requestId === this.activeRequestId) {
          this.loading = false
        }
      }
    },
    async preloadEnforcedPromos() {
      // Ensures that enforced compliance promos are popoulated so that
      // nonCompliance tooltip shows no promos
      if (this.$auth.tenant === 'alliance-retail-group' && this.isTprProRetailUser) {
        this.items.forEach(async item => {
          if (!this.srpIsCompliant(item)) {
            await this.calculateGrossProfit(item)
          }
        })
      }
    },
    onFiltersCleared() {
      // This method can be called by the SearchFilters component when all filters are cleared
      // Force a state restoration by calling it directly
      if (this.savedStateBeforeFilters && !this.hasFiltersApplied()) {
        this.restoreStateAfterFiltersRemoved()
      }
    },
    validateInputs(item) {
      if (item.promotion_price <= 0 || item.multiplier <= 0) {
        this.alert("SRP and Multiplier must be greater than zero.")
        return false
      }
      return true
    },
    showComplianceTooltip(item) {
      let showNonComplianceList = false
      if (this.isTprProRetailUser && !this.srpIsCompliant(item)) {
        showNonComplianceList = true 
      }
      let showMutlipleSelectionWarning = this.hasSelections
      return showNonComplianceList || showMutlipleSelectionWarning
    },
    handleEnterKey(currentRowIndex, fieldName, event) {
      event.preventDefault()
      let nextRow = currentRowIndex + 1
      // Target the specific field in next row
      let nextField = document.querySelector(
        `[data-row="${nextRow}"][data-field="${fieldName}"]`
      )
      // Skip disabled rows
      while (nextField && this.srpIsDisabled(nextField)) {
        nextRow += 1
        nextField = document.querySelector(
          `[data-row="${nextRow}"][data-field="${fieldName}"]`
        )
      }
      nextField?.focus()
      nextField?.select()
    },
    handleShuttleWholeBatch() {
      this.shuttleChanges(true)
    },
    blurActiveElement() {
      document.activeElement.blur()
    },
    saveCurrentSession() {
      if (this.$auth.tenant !== 'alliance-retail-group') return
      // For store users, use tpr_batch_id instead of id
      const batchId = this.isTprProRetailUser ? this.selectedBatch.tpr_batch_id : this.selectedBatch.id
      const sessionData = {
        batchId: batchId,
        timestamp: new Date().toISOString(),
        page: this.page,
        pageSize: this.pageSize,
        searchParams: this.searchParams,
        sortBy: this.sortBy,
        displayHeaders: this.displayHeaders,
        hideHeaders: this.hideHeaders,
        searchValues: this.searchValues,
        userEmail: this.userEmail,
        version: '1.0'
      }
      const now = new Date()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const day = now.getDate().toString().padStart(2, '0')
      const year = now.getFullYear()
      const hour = now.getHours().toString().padStart(2, '0')
      const minute = now.getMinutes().toString().padStart(2, '0')
      // Sanitize batch name for filename use
      const sanitizedBatchName = (this.selectedBatch.batch_name || `batch_${this.selectedBatch.id}`)
        .replace(/[^a-zA-Z0-9\-_]/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '')
      const filename = `${sanitizedBatchName}_${month}_${day}_${year}_${hour}_${minute}.json`
      const blob = new Blob([JSON.stringify(sessionData, null, 2)], { type: 'application/json' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    saveStateBeforeFilters() {
      // Save current page and sorting state before applying filters
      if (!this.savedStateBeforeFilters) {
        // Create a plain object to avoid Vue reactivity issues
        const plainSortBy = this.sortBy ? this.sortBy.map(item => [...item]) : []
        this.savedStateBeforeFilters = Object.freeze({
          page: this.page,
          sortBy: plainSortBy,
          displayHeaders: this.displayHeaders ? [...this.displayHeaders] : []
        })
      }
    },
    async restoreStateAfterFiltersRemoved() {
      // Restore page and sorting state when all filters are removed
      if (this.savedStateBeforeFilters && !this.hasFiltersApplied()) {
        const savedState = this.savedStateBeforeFilters
        const savedPage = savedState.page
        const savedSortBy = savedState.sortBy
        try {
          this.isRestoringState = true
          await this.$nextTick()
          this.sortBy.splice(0)
          if (savedSortBy && savedSortBy.length > 0) {
            savedSortBy.forEach(sortItem => {
              this.sortBy.push([...sortItem])
            })
          }
          this.updateHeaderSortIndicators()
          this.page = savedPage
          this.from = (savedPage - 1) * this.pageSize
          await this.$nextTick()
          this.loadItems()
        } finally {
          this.isRestoringState = false
          this.savedStateBeforeFilters = null
        }
      }
    },
    hasFiltersApplied() {
      // Check if any filters are currently applied
      return Object.keys(this.searchParams).some(key => {
        const value = this.searchParams[key]
        return Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== ''
      })
    },
    onPageChanged(newPage) {
      // Update saved state when page changes manually (not via filter restoration)
      if (this.savedStateBeforeFilters && !this.hasFiltersApplied()) {
        // Create a new frozen object since the original is frozen
        this.savedStateBeforeFilters = Object.freeze({
          page: newPage,
          sortBy: this.savedStateBeforeFilters.sortBy,
          displayHeaders: this.savedStateBeforeFilters.displayHeaders
        })
      }
      if (this.storeGroupSelected) {
        const offset = (this.page - 1) * this.pageSize
        this.items = this.fullMultiStoreItems.slice(offset, offset + this.pageSize)
      }
    },
    triggerFileInput() {
      if (this.$auth.tenant !== 'alliance-retail-group') return
      this.$refs.sessionFileInput.click()
    },
    handleFileSelect(event) {
      if (this.$auth.tenant !== 'alliance-retail-group') return
      const file = event.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const sessionData = JSON.parse(e.target.result)
          // For store users, compare against tpr_batch_id instead of id
          const currentBatchId = this.isTprProRetailUser ? this.selectedBatch.tpr_batch_id : this.selectedBatch.id
          if (sessionData.batchId !== currentBatchId) {
            this.alert('This session file is for a different batch')
            return
          }
          this.restoreSessionData(sessionData)
        } catch (error) {
          this.alert('Invalid session file format')
        }
      }
      reader.readAsText(file)
      // Clear the input value so the same file can be selected again
      event.target.value = ''
    },
    restoreSessionData(sessionData) {
      try {
        this.isSessionRestoring = true
        this.isRestoringState = true
        // Restore page and pageSize first to trigger watchers
        this.pageSize = sessionData.pageSize || 100
        this.page = sessionData.page || 1
        // Restore other session data
        this.searchParams = sessionData.searchParams || {}
        this.sortBy = sessionData.sortBy || []
        this.displayHeaders = sessionData.displayHeaders || []
        this.hideHeaders = sessionData.hideHeaders || []
        this.searchValues = sessionData.searchValues || []
        // Apply search filters if they exist
        if (this.$refs.searchFilters && Object.keys(this.searchParams).length > 0) {
          this.$refs.searchFilters.params = { ...this.searchParams }
          // Set selected filters based on searchParams
          this.$refs.searchFilters.selectedFilters = Object.keys(this.searchParams).filter(key => {
            const value = this.searchParams[key]
            return Array.isArray(value) ? value.length > 0 : value !== '' && value !== null && value !== undefined
          })
        }
        // Reload items with restored state and ensure pagination is synchronized
        this.$nextTick(() => {
          this.loadItems()
          this.$nextTick(() => {
            this.updateHeaderSortIndicators()
            this.isRestoringState = false
            this.isSessionRestoring = false
          })
        })
        this.alert('Session restored successfully')
      } catch (error) {
        this.alert('Error restoring session: ' + error.message)
        this.isRestoringState = false
        this.isSessionRestoring = false
      }
    },
    updateHeaderSortIndicators() {
      // Reset all headers first
      this.allHeaders.forEach(header => {
        header.showArrow = false
        header.descending = false
      })
      // Reset displayHeaders as well
      this.displayHeaders.forEach(header => {
        header.showArrow = false
        header.descending = false
      })
      // Update headers based on current sortBy state
      this.sortBy.forEach(([column, direction]) => {
        // Update allHeaders
        const allHeader = this.allHeaders.find(h => h.value === column)
        if (allHeader) {
          allHeader.showArrow = true
          allHeader.descending = direction === 'desc'
        }
        // Update displayHeaders
        const displayHeader = this.displayHeaders.find(h => h.value === column)
        if (displayHeader) {
          displayHeader.showArrow = true
          displayHeader.descending = direction === 'desc'
        }
      })
    },
    filterByLinkedGroup(linkedGroup) {
      // Alliance-only feature
      if (this.$auth.tenant !== 'alliance-retail-group') return
      // Save state before applying filter
      this.saveStateBeforeFilters()
      this.isRestoringState = true
      this.page = 1
      this.from = 0
      this.searchParams = {
        ...this.searchParams,
        linked_group: [linkedGroup]
      }
      this.$nextTick(() => {
        this.isRestoringState = false
        if (this.$refs.searchFilters) {
          this.$refs.searchFilters.params.linked_group = [linkedGroup]
          if (!this.$refs.searchFilters.selectedFilters.includes('linked_group')) {
            this.$refs.searchFilters.selectedFilters.push('linked_group')
          }
          this.$refs.searchFilters.triggerSearch()
        }
      })
      this.loadItems()
      this.$nextTick(() => {
        this.selectAllLinkedGroupItems(linkedGroup)
      })
    },
    selectAllLinkedGroupItems(linkedGroup) {
      const linkedGroupItems = this.items.filter(item => 
        item.linked_group === linkedGroup && 
        (item.excluded === '' || item.excluded === null)
      )
      if (!this.isEditingDisabled) this.selected = linkedGroupItems
    },
    truncateToTwoDecimals(value) {
      if (value === '' || value === null || value === undefined) {
        return value
      }
      const stringValue = String(value)
      const decimalIndex = stringValue.indexOf('.')
      const truncated = decimalIndex > -1 ? 
        stringValue.substring(0, decimalIndex + 3) 
        : stringValue
      return parseFloat(truncated).toFixed(2)
    },
    handleSRPBlur(item, event) {
      const originalValue = event.target.value
      const truncatedValue = this.truncateToTwoDecimals(originalValue)
      if (originalValue !== String(truncatedValue)) {
        if (item) {
          item.promotion_price = truncatedValue
          this.updateGrossProfit(item)
          this.$nextTick(() => {
            if (event.target.getAttribute('data-field') === 'promotion_price') {
              this.srprefresh += 1
            }
          })
        } else {
          this.srp = truncatedValue
        }
      }
    },
    formatAllSRPValues(items) {
      items.forEach(item => {
        if (item.promotion_price !== null && item.promotion_price !== undefined) {
          item.promotion_price = parseFloat(item.promotion_price).toFixed(2)
        }
      })
    },
    extractBanners(data) {
      let allBanners = new Set()
      data.forEach(item => {
        if (item.comp_pricing) {
          try {
            const parsedPricing = JSON.parse(item.comp_pricing)
            parsedPricing.forEach(banner => {
              if (banner.banner) {
                //replace spaces with underscores
                banner.banner = banner.banner.replace(/\s/g, '_')
                allBanners.add(banner.banner)
              }
            })
          } catch (e) {
            console.error('Failed to parse comp_pricing:', e)
          }
        }
      })
      // Always add walmart as a banner to ensure we get N/A for walmart values since WALMART header in included by default
      if (!allBanners.has("WALMART")) { allBanners.add("WALMART") }
      return allBanners
    },
    getBannerPrice(compPricing, banner) {
      if (!compPricing) return 0
      try {
        const parsedPricing = JSON.parse(compPricing)
        const bannerData = parsedPricing.find(b => b.banner === banner)
        return bannerData ? parseFloat(bannerData.regular_price_mode) : 0
      } catch (e) {
        console.error('Failed to parse comp_pricing:', e)
        return 0
      }
    },
    async updateGrossProfit(item) {
      item.net_gross_profit = await this.calculateGrossProfit(item)
    },
    getNonComplianceTooltip(hasSelections, item) {
      if (hasSelections) return 'Cannot edit SRP while items are selected'
      else return `This item is out of compliance for the following promos: ${item.nonCompliantList}`
    },
    async calculateGrossProfit(item) {
      if (item.multiplier <= 0 || item.promotion_price <= 0) {
        // Return 0.00% for invalid inputs
        return 0.00
      }
      let allowances = Number(item.amap_allowance) + Number(item.dsd_oi_allowance) + Number(item.billback_allowance) + Number(item.tpr_billback_allowance) + Number(item.edlc_billback_allowance) + Number(item.vpap_tpr_billback_allowance) + Number(item.accrual_tpr_billback_allowance)
      // Exclude Early Buy Allowance from calculation for ARG Non-Perishable batches only
      if (this.$auth.tenant != 'alliance-retail-group' || this.selectedBatch?.batch_type?.toUpperCase() === 'PERISHABLE') {
        allowances += Number(item.early_buy_allowance)
      }
      let scanAllowances = Number(item.scan_allowance) + Number(item.edlc_scan_allowance) + Number(item.tpr_scan_allowance)
      let nonCompliantList = []
      // Map promo categories to the corresponding allowance column
      const catToCol = {
        "TPR Scan - ePay": "tpr_scan_epay_allowance",
        "TPR Scan - Compete": "tpr_scan_compete_allowance",
        "EDLC Scan - ePay": "edlc_scan_epay_allowance",
        "EDLC Scan - Compete": "eldc_scan_compete_allowance"
      }
      if (this.isTprProRetailUser &&
          item.enforce_compliance && 
          item.enforce_compliance_promos == undefined) {
        const res = await Rules.getEnforcedPromos(
          this.selectedBatch.tpr_batch_id, 
          this.selectedStore.store_party_id, 
          item.item_id
        )
        item.enforce_compliance_promos = res.data
      }
      if (this.isTprProRetailUser) {
        item.enforce_compliance_promos?.forEach((promo) => {
          let col = catToCol[promo.promo_category_name]
          if (item.promotion_price <= (parseFloat(promo.promotion_price) + (parseFloat(item.variance) || 0))) {
            scanAllowances += item[col] ?? 0
          }
          else {
            nonCompliantList.push(promo.promo_category_name)
          }
        })
        this.$set(item, 'nonCompliantList', nonCompliantList)
      } else {
        scanAllowances += Number(item.tpr_scan_compete_allowance) + Number(item.tpr_scan_epay_allowance) + Number(item.edlc_scan_compete_allowance) + Number(item.edlc_scan_epay_allowance)
      } 
      let cost_source = item.cost
      if (this.tprProTenants && item.case_freight != null) {
        cost_source = item.case_freight
      }
      const unitCost = ((Number(cost_source) - allowances) / Number(item.qty_per_case)) - scanAllowances
      item.net_unit_cost = Math.round(unitCost * 100) / 100
      const grossProfit = (((Number(item.promotion_price) / Number(item.multiplier)) - unitCost) / (Number(item.promotion_price) / Number(item.multiplier))) * 10000
      return Math.round(grossProfit) / 100
    },
    syncHeadersOrder() {
      const userEmail = this.userEmail
      let allUserHeaders = JSON.parse(localStorage.getItem("userHeaders")) || {}
      allUserHeaders[userEmail] = this.selectedHeaders
      localStorage.setItem("userHeaders", JSON.stringify(allUserHeaders))
      const reorderedHeaders = this.allHeaders.filter(header =>
        this.selectedHeaders.includes(header.value)
      )
      this.displayHeaders = reorderedHeaders.sort((a, b) => {
        return this.selectedHeaders.indexOf(a.value) - this.selectedHeaders.indexOf(b.value)
      })
      this.hideHeaders = this.allHeaders.filter(header =>
        !this.selectedHeaders.includes(header.value)
      )
    },
    loadUserHeaders() {
      const userEmail = this.userEmail
      const allUserHeaders = JSON.parse(localStorage.getItem("userHeaders")) || {}
      if (allUserHeaders[userEmail]) {
        this.selectedHeaders = allUserHeaders[userEmail]
      } else {
        this.resetHeaders()
      }
      this.syncHeadersOrder()
    },
    saveHeadersOrder() {
      const userEmail = this.userEmail
      let allUserHeaders = JSON.parse(localStorage.getItem("userHeaders")) || {}
      allUserHeaders[userEmail] = this.selectedHeaders
      localStorage.setItem("userHeaders", JSON.stringify(allUserHeaders))
      this.showModal = false
    },
    resetHeaders() {
      const userEmail = this.userEmail
      let allUserHeaders = JSON.parse(localStorage.getItem('userHeaders')) || {}
      delete allUserHeaders[userEmail]
      localStorage.setItem('userHeaders', JSON.stringify(allUserHeaders))
      this.selectedHeaders = this.allHeaders.flatMap(header => 
          header.default_show ? header.value : []
      )
      this.syncHeadersOrder()
      this.showModal = false
    },
    onDragEnd() {
      // Ensure checkbox header remains in displayHeaders
      if (!this.displayHeaders.some(header => header.value === 'data-table-select')) {
        const checkboxHeader = this.allHeaders.find(header => header.value === 'data-table-select')
        if (checkboxHeader) {
          this.displayHeaders.unshift(checkboxHeader)
          this.hideHeaders = this.hideHeaders.filter(header => header.value !== 'data-table-select')
        }
      }
      const displayHeaderValues = this.displayHeaders.map(header => header.value)
      this.selectedHeaders = displayHeaderValues
    },
    async getPromosByRow(item) {
      const { id } = item
      const tprId = id
      try {
        const { data } = await Items.getPromosByRow(
          this.selectedBatch.id,
          tprId
        )
        this.selectedRow = data
      } catch (err) {
        console.log(err)
      }
    },
    openModal() {
      this.showModal = true
    },
    openLink(promoId) {
      let baseUrl = process.env.VUE_APP_PROMO_PORTAL
      let prefix = this.$auth.tenantURLPrefix
      if (prefix) {
        baseUrl = `${prefix}.${baseUrl}`
      }
      const url = `https://${baseUrl}/promo?id=${promoId}`
      window.open(url)
    },
    async loadPromotionData(item, promotionCategory) {
      if (this.$auth.tenant !== 'alliance-retail-group') {
        return
      }
      if (this.selectedPromotionItem === item && 
          this.selectedPromotionCategory === promotionCategory) {
        return
      }
      this.selectedPromotionItem = item
      this.selectedPromotionCategory = promotionCategory
      this.loadingPromoPrice = true
      this.promoPromotionPriceData = null
      if (promotionCategory === 'tpr_scan_epay') {
        this.selectedPromotionAllowance = item.tpr_scan_epay_allowance
      } else if (promotionCategory === 'tpr_scan_compete') {
        this.selectedPromotionAllowance = item.tpr_scan_compete_allowance
      }
      try {
        let promoResponse
        if (this.isTprProRetailUser) {
          promoResponse = await Rules.getPromoPromotionPrice(
            this.selectedBatch.tpr_batch_id,
            item.item_id,
            promotionCategory
          )
        } else {
          promoResponse = await Items.getPromoPromotionPrice(
            this.selectedBatch.id,
            item.item_id,
            promotionCategory
          )
        }
        this.promoPromotionPriceData = promoResponse.data
      } catch (promoErr) {
        console.warn('Could not fetch promotion data from api_promo.promotion table:', promoErr)
      } finally {
        this.loadingPromoPrice = false
      }
    },
    async toggleExcluded(item) {
      if (this.isEditingDisabled) {
        return
      }
      try {
          if (item.excluded === '' || item.excluded === null) {
            item.excluded = 'manual'
          }
          else if( item.excluded) {
            item.excluded = ''
          }
          else if (item.excluded === 'manual') {
            item.excluded = ''
          }
        if (!this.isTprProRetailUser) {
          await Items.updateExcludeInclude(item.id, item.excluded)
        } else {
          await Rules.saveExclusion(item.id, this.$auth.user.email, item.excluded)
        }
      } catch (error) {
        console.error('Error while toggling exclusion: ', error)
      }
    },
    getRowClass(item) {
      let classList = ''
      const promotion_price = item.promotion_price !== undefined ? item.promotion_price : item.srp
      if (item.gross_profit_percent === null || promotion_price <= 0 || item.multiplier <= 0) {
        return 'red white--text '
      }
      if (this.tprProTenants) {
        if (item.excluded !== '') classList += 'disabled-row '
        if (item.gross_profit_percent === null) classList += 'red white--text '
      } else {
        if (item.gross_profit_percent === null) classList += 'red white--text '
      }
      if (this.changes.some(change => change.id === item.id)) {
        if (!this.srpIsCompliant(item) && this.blockNonCompliantSaves) return 'red white--text '
        if (this.$auth.tenant === 'alliance-retail-group' && this.isTprProRetailUser && !this.passPercentIsCompliant(item)) {
          return 'red white--text'
        }
        if (this.tprProTenants) classList += 'yellow-row '
      }
      // Top Sellers are highlighted for ARG unless other styles are applied
      if (!classList && this.$auth.tenant === 'alliance-retail-group' && item.top_sellers) classList += 'light-blue lighten-4 '
      return classList.trim()
    },
    getWarningColor(item) {
      if (this.changes.some(change => change.id === item.id) && this.blockNonCompliantSaves)
        return 'white'
      return 'red'
    },
    parseRules(rulesApplied) {
      try {
        const parsedRules = typeof rulesApplied === 'string' ? JSON.parse(rulesApplied) : rulesApplied
        return parsedRules.map(rule => {
          if (rule.name && rule.name.toLowerCase().includes('discount')) {
            rule.displayValue = `$${rule.value}`
          } else if (rule.name && rule.name.toLowerCase().includes('pct')) {
            rule.displayValue = `${rule.value}%`
          } else {
            rule.displayValue = rule.value
          }
          return rule
        })
      } catch (err) {
        console.error('Failed to parse rules_applied:', err)
        return []
      }
    },
    computedPromotionPrice(item) {
      let price
      if (!this.isTprProRetailUser && this.tprProTenants) {
        if (item.version_id > 1) {
          price = item.promotion_price
        } else if (item.version_id === 1 && item.rules_applied) {
          price = item.rules_promotion_price
        } else {
          price = item.promotion_price
        }
      } else {
        price = item.promotion_price
      }
      return this.formatCurrencyDisplay(price)
    },
    hasRules(rulesApplied) {
      if (!rulesApplied || rulesApplied === '[]') return false
      try {
        const parsed = JSON.parse(rulesApplied)
        return Array.isArray(parsed) && parsed.length > 0
      } catch (err) {
        console.error('Invalid JSON in rules_applied:', err)
        return false
      }
    },
    getPriceComparisonColor(item) {
      if (!item.comp_pricing_mode || !item.promotion_price) return 'grey'
      const compprice = parseFloat(item.comp_pricing_mode)
      const userprice = parseFloat(item.promotion_price) / parseFloat(item.multiplier || 1)
      if (compprice === userprice) return 'grey'
      if (userprice > compprice) return 'red'
      return 'green'
    },
    getPriceComparisonIcon(item) {
      if (!item.comp_pricing_mode || !item.promotion_price) return 'mdi-minus'
      const compprice = parseFloat(item.comp_pricing_mode)
      const userprice = parseFloat(item.promotion_price) / parseFloat(item.multiplier || 1)
      if (compprice === userprice) return 'mdi-equal'
      if (userprice > compprice) return 'mdi-arrow-up'
      return 'mdi-arrow-down'
    },
    getPriceComparisonText(item) {
      if (!item.comp_pricing_mode || !item.promotion_price) return 'No price comparison available'
      const compprice = parseFloat(item.comp_pricing_mode)
      const userprice = parseFloat(item.promotion_price) / parseFloat(item.multiplier || 1)
      if (compprice === userprice) return `Prices are equal to $${compprice}`
      if (userprice > compprice) {
        const diff = ((userprice - compprice) / compprice * 100).toFixed(2)
        return `Price ${diff}% More Expensive than Competitor price of $${compprice}`
      }
      const diff = ((compprice - userprice) / compprice * 100).toFixed(2)
      return `Price ${diff}% Cheaper than Competitor price of $${compprice}`
    },
    getRuleDisplay(ruleKey) {
      const ruleMapping = {
        'ad_group': 'Ad Group',
        'store': 'Store',
        'department': 'Department',
        'category': 'Category',
        'vendor': 'Vendor'
      }
      return ruleMapping[ruleKey] || ruleKey
    },
    async handleSort(header) {
      // Save state before sorting if no filters are applied and no state is saved yet
      // (this captures the initial sorted state before any filters)
      if (!this.hasFiltersApplied() && !this.savedStateBeforeFilters) {
        this.saveStateBeforeFilters()
      }
      const existingSortIndex = this.sortBy.findIndex(([column]) => column === header.value)
      if (!['comp_pricing_mode', 'promo_info'].includes(header.value)) {
        if (existingSortIndex === -1) {
          this.sortBy.push([header.value, 'asc'])
          this.contextColumn = header.value
          header.descending = false
          header.showArrow = true
        } else {
          const currentOrder = this.sortBy[existingSortIndex][1]
          if (currentOrder === 'asc') {
            this.sortBy[existingSortIndex][1] = 'desc'
            header.descending = true
            this.contextColumn = header.value
          } else {
            // Remove the sort entirely instead of going back to asc
            this.sortBy.splice(existingSortIndex, 1)
            header.descending = false
            header.showArrow = false
            this.contextColumn = header.value
          }
        }
        if (!this.hasFiltersApplied() && this.savedStateBeforeFilters) {
          this.savedStateBeforeFilters = Object.freeze({
            page: this.savedStateBeforeFilters.page,
            sortBy: this.sortBy.map(item => [...item]),
            displayHeaders: this.savedStateBeforeFilters.displayHeaders
          })
        }
        // Update both allHeaders and displayHeaders
        this.updateHeaderSortIndicators()
        if (header.value.startsWith('comp_pricing_')) {
          this.sortItemsByCompPricing(header.value, header.descending ? 'desc' : 'asc')
        } else {
          this.loadItems()
        }
      }
    },
    sortItemsByCompPricing(column, order) {
      const banner = column.replace('comp_pricing_', '').replace(/_/g, ' ')
      this.items.sort((a, b) => {
        const valueA = this.getBannerPrice(a.comp_pricing, banner)
        const valueB = this.getBannerPrice(b.comp_pricing, banner)
        if (order === 'asc') {
          return valueA - valueB
        } else {
          return valueB - valueA
        }
      })
      this.loadItems()
    },
    async removeSort(header) {
      const indexToRemove = this.sortBy.findIndex(([column]) => column === header.value)
      if (indexToRemove !== -1) {
        this.sortBy.splice(indexToRemove, 1)
      }
      // Update header indicators
      this.updateHeaderSortIndicators()
      this.loadItems()
    },
    async removeAllSorts() {
      // Clear all sorting
      this.sortBy = []
      // Update header indicators
      this.updateHeaderSortIndicators()
      // If we have saved state and no filters are applied, update the saved state
      if (this.savedStateBeforeFilters && !this.hasFiltersApplied()) {
        // Create a new frozen object since the original is frozen
        this.savedStateBeforeFilters = Object.freeze({
          page: this.savedStateBeforeFilters.page,
          sortBy: [],
          displayHeaders: this.savedStateBeforeFilters.displayHeaders
        })
      }
      // Re-fetch the items without sorting
      this.loadItems()
    },
    async loadUniqueValues() {
      let batchId = this.selectedBatch.id
      //If batch id is set
      if (batchId) {
        if (this.isTprProRetailUser) {
          try {
            const categoryResponse = await Rules.getUniqueValues(batchId, 'category')
            this.categoryList = Array.isArray(categoryResponse.data) ? categoryResponse.data : []
          } catch (error) {
            this.alert('Error loading search category values')
            console.error(`Failed to load category values: ${error.message}`)
          }
          this.subcategoryList = null
          try {
            const departmentResponse = await Rules.getUniqueValues(batchId, 'department')
            this.departmentList = Array.isArray(departmentResponse.data) ? departmentResponse.data : []
          } catch (error) {
            this.alert('Error loading search department values')
            console.error(`Failed to load department values: ${error.message}`)
          }
          try {
            const promoCategoryResponse = await Rules.getUniqueValues(batchId, 'promo_category_name')
            this.promoCategoryList = Array.isArray(promoCategoryResponse.data) ? promoCategoryResponse.data : []
          } catch (error) {
            this.alert('Error loading search promo category values')
            console.error(`Failed to load promo category values: ${error.message}`)
          }
          try {
            const vendorResponse = await Rules.getUniqueValues(batchId, 'vendor')
            this.vendorList = Array.isArray(vendorResponse.data) ? vendorResponse.data : []
          } catch (error) {
            this.alert('Error loading search vendor values')
            console.error(`Failed to load vendor values: ${error.message}`)
          }
      } else {
          try {
            const categoryResponse = await Items.getUniqueValues(batchId, 'category')
            this.categoryList = Array.isArray(categoryResponse.data) ? categoryResponse.data : []
          } catch (error) {
            this.alert('Error loading search category values')
            console.error(`Failed to load category values: ${error.message}`)
          }
          if (this.$auth.tenant == 'awg') {
            try {
              const subcategoryResponse = await Items.getUniqueValues(batchId, 'subcategory')
              this.subcategoryList = Array.isArray(subcategoryResponse.data) ? subcategoryResponse.data : []
            } catch (error) {
              this.alert('Error loading search subcategory values')
              console.error(`Failed to load subcategory values: ${error.message}`)
            }
          }
          else {
            this.subcategoryList = null
          }
          try {
            const departmentResponse = await Items.getUniqueValues(batchId, 'department')
            this.departmentList = Array.isArray(departmentResponse.data) ? departmentResponse.data : []
          } catch (error) {
            this.alert('Error loading search department values')
            console.error(`Failed to load department values: ${error.message}`)
          }
          try {
            const promoCategoryResponse = await Items.getUniqueValues(batchId, 'promo_category_name')
            this.promoCategoryList = Array.isArray(promoCategoryResponse.data) ? promoCategoryResponse.data : []
          } catch (error) {
            this.alert('Error loading search promo category values')
            console.error(`Failed to load promo category values: ${error.message}`)
          }
          try {
            const vendorResponse = await Items.getUniqueValues(batchId, 'vendor')
            this.vendorList = Array.isArray(vendorResponse.data) ? vendorResponse.data : []
          } catch (error) {
            this.alert('Error loading search vendor values')
            console.error(`Failed to load vendor values: ${error.message}`)
          }
        }
      }
    },
    async resetRow(item) {
      this.loading = true
      try {
        const originalItem = this.originalItems.find(origItem => origItem.id === item.id)
        if (originalItem) {
          this.$set(item, 'multiplier', originalItem.multiplier)
          this.$set(item, 'promotion_price', originalItem.promotion_price)
          this.$set(item, 'net_gross_profit', originalItem.net_gross_profit)
          this.srprefresh++
          const itemIndex = this.items.findIndex(i => i.id === item.id)
          if (itemIndex !== -1) {
            this.$set(this.items, itemIndex, { ...this.items[itemIndex], multiplier: originalItem.multiplier, promotion_price: originalItem.promotion_price })
          }
        }
        this.changes = this.changes.filter(change => change.id !== item.id)
        this.notify('Row reset successfully')
      } catch (err) {
        console.error(err)
        const message = err?.response?.data?.message || err.message
        this.alert(`Error resetting values: ${message}`)
      } finally {
        this.loading = false
      }
    },
    resetChanges() {
      this.changes = []
      localStorage.removeItem(`changes_${this.selectedBatch.id}`)
      this.items = JSON.parse(JSON.stringify(this.originalItems))
    },
    cleanupOtherBatchChanges() {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key.startsWith('changes_') && key !== `changes_${this.selectedBatch.id}`) {
          localStorage.removeItem(key)
        }
      }
    },
    handleBeforeUnload(event) {
      if (this.hasActiveChanges) {
        event.preventDefault()
        event.returnValue = ''
      }
    },
    refreshPage() {
      this.changes = []
      localStorage.removeItem(`changes_${this.selectedBatch.id}`)
      location.reload()
    },
    async noteUpdate(item) {
      const payload = [
        {
          id: item.id,
          promotion_price: item.promotion_price,
          multiplier: item.multiplier,
          note: item.note,
          net_gross_profit: item.net_gross_profit,
        }
      ]
      try {
        await Items.tprUpdate(payload)
        this.notify('Note updated successfully')
      } catch (err) {
        console.error(err)
        const message = err?.response?.data?.message || err.message
        this.alert(`Error updating note: ${message}`)
      } finally {
        this.loadItems()
        this.loading = false
      }
    },
    passPercentIsCompliant(item) {
      let passThruCompliant = true
      let nonPerishable = this.selectedBatch?.batch_type.toUpperCase() === 'NON PERISHABLE'
      if (this.$auth.tenant === 'alliance-retail-group' && this.isTprProRetailUser && item.retail_price != 0 && nonPerishable) {
        let maxSRP = Math.max(item.max_srp_for_passthrough_percent || 0, item.rules_promotion_price || 0)
        if (maxSRP > 0) {
          passThruCompliant = (parseFloat(item.promotion_price) / item.multiplier) <= maxSRP
        }
        if (!passThruCompliant) {
          this.alert(`Item ${item.item_id} must have an SRP at or below $${(maxSRP * item.multiplier).toFixed(2)}`)
        }
      }
      return passThruCompliant
    },
    async srpUpdate(item, srp) {
      if (this.isEditingDisabled) return
      if (!this.validateInputs(item)) return
      // trunc SRP to 2 decimals without rounding
      if (srp !== '' && srp !== null && srp !== undefined) {
        srp = this.truncateToTwoDecimals(srp)
        item.promotion_price = srp
      }
      this.loading = true
      let payload = []
      if (this.selected.length) {
        this.selected.forEach(async item => {
            item.promotion_price = this.truncateToTwoDecimals(this.srp)
            item.net_gross_profit = await this.calculateGrossProfit(item)
        })
      } else {
        payload = [
          {
            id: item.id,
            promotion_price: srp,
            multiplier: item.multiplier,
            note: item.note,
            net_gross_profit: await this.calculateGrossProfit(item),
          }
        ]
      }
      // Logic in place to seperate between a Store User and an Ad group User -- specific flag: this.isTprProRetailUser
      if(!this.isTprProRetailUser){
        try {
          await Items.tprUpdate(payload)
          this.selected = []
          this.srp = ''
          this.srpMenu = false
          this.notify('SRP updated successfully')
        } catch (err) {
          console.error(err)
          const message = err?.response?.data?.message || err.message
          this.alert(`Error updating SRP: ${message}`)
        } finally {
          this.loadItems()
          this.loading = false
        }
      } else {
        this.storeSrpMultiplierUpdate(payload) //item, null, srp
      }
    },
    async storeSrpMultiplierUpdate(payload) {
      try {
        const response = await Rules.storeSrpMultiplier(payload)
        if (response.data && response.data.message) {
          if (response.data.message === 'TPR successfully updated.') {
            this.notify(response.data.message)
          } else {
            this.alert(response.data.message)
          }
        } else {
          this.notify('Item updated successfully')
        }
        this.selected = []
        this.srp = ''
        this.srpMenu = false
      } catch (err) {
        console.error('store side srp & multiplier error: ', err)
        const message = err?.response?.data?.message || err.message
        this.alert(`Error updating store items: ${message}`)
      } finally {
        await this.getItems()
      }
    },
    async multiplierUpdate(item, multiplier) {
      if (this.isEditingDisabled) return
      if (!this.validateInputs(item)) return
      const payload = [
        {
          id: item.id,
          promotion_price: item.promotion_price,
          multiplier: multiplier,
          note: item.note,
          net_gross_profit: item.net_gross_profit
        }
      ]
      try {
        await Items.tprUpdate(payload)
        this.notify('Multiplier updated successfully')
      } catch (err) {
        console.error(err)
        const message = err?.response?.data?.message || err.message
        this.alert(`Error updating multiplier: ${message}`)
      } finally {
        await this.loadItems()
        this.loading = false
      }
    },
    async handleInput(item, event, field) {
      if (this.isEditingDisabled) return
      if (!event || !event.target) {
        console.error('Invalid event object:', event)
        return
      }
      let value = event.target.value
      const existingChange = this.changes.find(change => change.id === item.id)
      if (existingChange) {
        existingChange[field] = value
      } else {
        const originalItem = this.originalItems.find(origItem => origItem.id === item.id)
        if (!originalItem) {
          this.originalItems.push({ ...item })
        }
        this.changes.push({ id: item.id, [field]: value, item_id: item.item_id })
      }
      item[field] = value
      await this.updateGrossProfit(item)
    },
    async prepareToSave() {
      if (this.isEditingDisabled) return
      let priceOutsideOfCompliance = false
      // Warn NON-ARG Manager users if saving SRP values outside of compliance
      if (this.isTprProRetailUser) {
        for (const change of this.changes) {
          const item = this.items.find(i => i.id === change.id) || this.originalItems.find(i => i.id === change.id)
          if (item) {
            if (item.enforce_compliance && !this.srpIsCompliant(item)) {
              priceOutsideOfCompliance = true
              break
            }
          }
        }
        if (priceOutsideOfCompliance) {
          this.showConfirmPopup = true
          return
        } 
      }
      await this.saveChanges()
    },
    cancelConfirm() {
      this.loading = false
      this.confirmChecked = false
      this.showConfirmPopup = false
    },
    async saveChanges() {
      if (this.isEditingDisabled) return
      this.showConfirmPopup = false
      this.confirmChecked = false
      this.loading = true
      const payloads = []
      for (const change of this.changes) {
        const item = this.items.find(i => i.id === change.id) || this.originalItems.find(i => i.id === change.id)
        if (item) {
          const payload = {
            id: item.id,
            promotion_price: change.promotion_price !== undefined ? change.promotion_price : item.promotion_price,
            multiplier: change.multiplier !== undefined ? change.multiplier : item.multiplier,
            note: item.note,
            net_gross_profit: item.net_gross_profit,
          }
          payloads.push(payload)
        }
      }
      if (payloads.length > 0 && !this.isTprProRetailUser) {
        try {
          await Items.tprUpdate(payloads)
          this.notify('Changes saved successfully')
        } catch (err) {
          console.error(err)
          const message = err?.response?.data?.message || err.message
          this.alert(`Error updating items: ${message}`)
        } finally {
          this.loadItems()
        }
      } else if (this.isTprProRetailUser) {
        await this.storeSrpMultiplierUpdate(payloads)
      }
      this.changes = []
      this.originalItems = []
      this.selected = []
      this.srp = ''
      this.srpMenu = false
      this.loading = false
    },
    async shuttleChanges(wholeBatch = false) {
      this.loading = true
      if (wholeBatch) {
        let response
        if (this.isTprProRetailUser) {
          response = await Rules.getChangedItems(this.selectedStore.store_party_id, this.selectedBatch.tpr_batch_id)
        } else {
          response = await Items.getChangedItems(this.selectedBatch.id)
        }
        this.changesAvailableForShuttle = response.data.map(item => ({
          upc: item.upc,
          itemId: item.item_id,
          itemDescription: item.description,
          multiplier: item.multiplier,
          srp: item.promotion_price,
          net_gross_profit: item.net_gross_profit,
          excluded: item.excluded,
          changedColumns: [],
        }))
      }
      else {
        this.changesAvailableForShuttle = this.changes.map(change => {
          const item = this.items.find(i => i.id === change.id)
          if (!item) {
            console.error(`Missing item data for change ID: ${change.id}`)
            return null
          }
          const multiplier = change.multiplier !== undefined ? change.multiplier : item.multiplier
          const srp = change.promotion_price !== undefined ? change.promotion_price : item.srp
          const net_gross_profit = change.net_gross_profit !== undefined ? change.net_gross_profit : item.net_gross_profit
          const excluded = change.excluded !== undefined ? change.excluded : item.excluded
          const changedColumns = []
          if (change.multiplier !== undefined) changedColumns.push('multiplier')
          if (change.promotion_price !== undefined) changedColumns.push('srp')
          if (change.net_gross_profit !== undefined) changedColumns.push('net_gross_profit')
          if (change.excluded !== undefined) changedColumns.push('excluded')
          return {
            upc: item.upc,
            itemId: item.item_id,
            itemDescription: item.description,
            multiplier,
            srp,
            net_gross_profit,
            excluded,
            changedColumns,
            ...change
          }
        }).filter(Boolean)
      }
      this.adShuttleDialog = true
      this.loading = false
    },
    confirmShuttleChanges() {
      this.$emit('confirmShuttleChanges')
      this.adShuttleDialog = true
    },
    cancelShuttleChanges() {
      this.$emit('cancelShuttleChanges')
    },
    openBulkMenu() {
      this.srpMenu = true
      this.multiplier = 1
    },
    async bulkUpdate() {
      if (this.isEditingDisabled) return
      // Truncate SRP to 2 decimal places (no rounding)
      if (this.srp !== '' && this.srp !== null && this.srp !== undefined) {
        this.srp = this.truncateToTwoDecimals(this.srp)
      }
      if (this.srp <= 0 || this.multiplier <= 0) {
        this.alert("SRP and Multiplier must be greater than zero.")
        return
      }
      if (this.tprProTenants) {
        console.log("Bulk applying")
        this.bulkApply()
      } else {
        this.bulkSave()
      }
    },
    async bulkSave() {
      this.loading = true
      let payload = await Promise.all(this.selected.map(async item => {
        const promo_price = this.srp ? this.truncateToTwoDecimals(this.srp) : this.truncateToTwoDecimals(item.promotion_price)
        const mult = this.multiplier ? this.multiplier : item.multiplier
        return {
          id: item.id,
          promotion_price: promo_price,
          multiplier: mult,
          note: item.note,
          net_gross_profit: await this.calculateGrossProfit({...item, promotion_price: promo_price, multiplier: mult})
        }
      }))
      if (!this.isTprProRetailUser) {
        try {
          await Items.tprUpdate(payload)
          this.selected = []
          this.srp = ''
          this.srpMenu = false
          this.notify('TPR updated successfully')
        } catch (err) {
          console.error(err)
          const message = err?.response?.data?.message || err.message
          this.alert(`Error updating TPR: ${message}`)
        } finally {
          this.loadItems()
          this.loading = false
        }
      } else {
        this.storeSrpMultiplierUpdate(payload)
      }
    },
    async bulkApply() {
      if (this.isEditingDisabled) return
      // Applies data to the SRP input boxes, but doesn't save it in the backend. Must use save button to save in DB
      for (const item of this.selected) {
        const newSRP = this.srp ? this.truncateToTwoDecimals(this.srp) : this.truncateToTwoDecimals(item.promotion_price)
        const newMult = this.multiplier ? this.multiplier : item.multiplier
        const existingChange = this.changes.find(change => change.id === item.id)
        const grossProfitItem = {...item, promotion_price: newSRP, multiplier: newMult}
        if (existingChange) {
          existingChange['promotion_price'] = newSRP
          existingChange['multiplier'] = newMult
          existingChange['net_gross_profit'] = await this.calculateGrossProfit(grossProfitItem)
        } else {
          const originalItem = this.originalItems.find(origItem => origItem.id === item.id)
          if (!originalItem) {
            this.originalItems.push({ ...item })
          }
          this.changes.push({ id: item.id, promotion_price: newSRP, multiplier: newMult, item_id: item.item_id, net_gross_profit: await this.calculateGrossProfit(grossProfitItem) })
        }
        item.promotion_price = newSRP
        item.multiplier = newMult
      }
      this.selected = []
      this.srp = ''
      this.multiplier = ''
      this.srpMenu = false
      this.notify('TPR Updated - Save changes to confirm')
      this.loadItems()
    },
    async bulkDelete() {
      if (this.isEditingDisabled) return
      this.loading = true
      try {
        await Promise.allSettled(
          this.selected.map(item => Items.tprDelete(item.id))
        )
        this.deleteMenu = false
        this.selected = []
        this.notify('TPRs deleted successfully')
      } catch (err) {
        console.error(err)
        const message = err?.response?.data?.message || err.message
        this.alert(`Error deleting TPRs: ${message}`)
      } finally {
        this.loadItems()
      }
    },
    async showLinkedGroupModal(item) {
      if (item.promotion_price <= 0 || item.multiplier <= 0) {
        this.alert("SRP and Multiplier must be greater than zero.")
        return false
      }
      this.linkedGroupItem = item
      this.linkedGroupModal = true
    },
    linkedGroupUpdated (changedItems) {
      changedItems.forEach(item => {
        this.changes = this.changes.filter(changedItem => changedItem.id != item.id)
      })
      this.getItems()
    },
    beforeDestroy() {
      this.$root.$off("shuttleWholeBatch", this.handleShuttleWholeBatch)
      window.removeEventListener('beforeunload', this.handleBeforeUnload)
    },
    calculateDifferenceToRegularPrice(item) {
      if (!item.multiplier || item.multiplier <= 0) return 0
      const promotionPricePerUnit = (item.promotion_price || 0) / item.multiplier
      return promotionPricePerUnit - (item.retail_price || 0)
    },
    formatName(value) {
      if (value.length <= this.truncateAt) return value
      return value.substring(0, this.truncateAt) + "..."
    },
    srpIsDisabled(srpInputField) {
      return srpInputField?.hasAttribute('disabled')
    },
    srpIsCompliant(item) {
      // If item doesn't even need to be enforced, it is compliant - return true
      if (item.enforce_compliance == false) { return true }
      let complianceLimit = 0
      if (this.isTprProRetailUser) {
        complianceLimit = (parseFloat(item.original_promotion_price) + parseFloat(item.variance)).toFixed(2) * item.multiplier
      } else {
        complianceLimit = parseFloat(item.rules_promotion_price + item.variance).toFixed(2) * item.multiplier
      }
      let formattedPrice = parseFloat(item.promotion_price)
      if (formattedPrice > complianceLimit) return false
      return true
    },
    srpAndMultColor(item) {
      if (this.$auth.tenant === 'alliance-retail-group' && this.isTprProRetailUser && !this.srpIsCompliant(item)) {
        return 'red' 
      } else {
       return ['awg', 'alliance-retail-group'].includes(this.$auth.tenant) && item.version_id > 1 ? 'blue-grey lighten-3' : 'input'
      }
    }
  }
}
</script>
<style>
.table >>> tbody tr.v-data-table__expanded__content {
  background: #eeeeee;
  box-shadow: none;
}
.disabled-row {
  opacity: 0.5;
}
.yellow-row {
  background-color: yellow;
}
.v-data-table tbody tr.yellow-row:hover {
  background-color: yellow !important;
}
.headerModal {
  padding: 10px;
  margin: 0%
}
.flex-right {
  display: inline-flex;
  justify-content: flex-end !important;
  gap: 10px;
  align-items: center;
  flex-wrap: nowrap;
}
.flex-right>* {
  flex-grow: 0;
  flex-shrink: 1;
  white-space: nowrap;
}
.fixed-search-filters {
  width: 550px;
  flex-grow: 0;
  flex-shrink: 1;
  min-width: 100px;
  overflow: visible;
}
.header-column-name {
  text-align: center; 
  margin-bottom: 10px; 
  font-weight: bold; 
  max-width: 80%;
}
.list-group {
  margin-top: 10px;
  min-height: 100%
}
.list-group-item {
  padding: 8px; 
  border: 1px solid #e0e0e0;
  margin-bottom: 2px; 
  border-radius: 4px;
  max-width: 80%;
}
.centered-title {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.cursor-pointer:hover {
  opacity: 0.8;
}
/* Default value is 0.12 for the opacity */
.dark-dividers tbody tr td {
  border-bottom: thin solid rgba(0, 0, 0, 0.35) !important; 
}
</style>